// 絞り込みガイド（sections/collection-selection-guide.liquid）の本体。
// セクションに直書きすると 256KB の上限を超えてコレクション系ページが 404 になるので、
// ここに出してセクション側から MJSelectionGuide(section.id, current_tags) で呼ぶ（#595 L11）。
// 同じページにガイドが複数載っても、呼び出しごとに閉じた状態を持つ。
window.MJSelectionGuide = function (sectionId, currentTags) {
  var root = document.getElementById('SelectionGuide-' + sectionId);
  var disclosure = document.getElementById('SGDisclosure-' + sectionId);
  var resultsWrap = document.getElementById('SGResults-' + sectionId);
  if (!root || !disclosure || !resultsWrap) return;

  // `#selection-guide` で来たときの着地。アンカーは <details> の外にあるので
  // ブラウザ任せでも位置は合うが、畳んだままだと高さ70pxのバーしか見えない。
  // **開いてから**位置を合わせ直す（開いた分の高さはバーの下に伸びるので、
  // 着地点そのものは動かない）。
  function landOnGuide(smooth) {
    if (location.hash !== '#selection-guide') return;
    disclosure.open = true;
    var anchor = document.getElementById('selection-guide') || disclosure;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(function () {
      anchor.scrollIntoView({ behavior: smooth && !reduced ? 'smooth' : 'auto', block: 'start' });
    });
  }
  // 読み込み時は瞬間移動。別ページのバナーから降りてくる導線なので、
  // 長いページを流して見せる意味がない（ブラウザの既定の着地と同じ挙動）。
  landOnGuide(false);
  // 同じページ内のリンクを押したときだけ滑らせる。
  window.addEventListener('hashchange', function () {
    landOnGuide(true);
  });

  var handle = root.getAttribute('data-sg-handle');
  // 母集合の取り先。'collection' はコレクションの Ajax API、'search' は
  // 検索結果の代替テンプレート（templates/search.sgdata.liquid）。
  var SOURCE = root.getAttribute('data-sg-source') || 'collection';
  var QUERY = root.getAttribute('data-sg-query') || '';
  // メーカー指定（旧タグURLの `maker:lixil` など。Liquid の sg_scope_tag）。Refs #595
  // 空でなければ、母集合はどの経路で取ってもこのタグの商品だけにする:
  // sgdata とタグ取得は URL にタグを足してストア側で絞り、索引は同じタグの行だけ残す。
  var SCOPE_TAG = (root.getAttribute('data-sg-scope-tag') || '').trim();
  // 旧タグURLのパス部分（`/maker%3Alixil`）。指定が無ければ空で、URL は今までと同じ
  function scopePath(extraTag){
    var tags = [];
    if (SCOPE_TAG) tags.push(SCOPE_TAG);
    if (extraTag && extraTag.toLowerCase() !== SCOPE_TAG.toLowerCase()) tags.push(extraTag);
    // 複数タグは `+` でつなぐと AND になる（Shopify の旧タグURLの読み方）
    return tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '';
  }
  var stepsEl = root.querySelector('[data-sg-steps]');
  var breadcrumbEl = root.querySelector('[data-sg-breadcrumb]');
  var sideEl = resultsWrap.querySelector('[data-sg-side]');
  var gridEl = resultsWrap.querySelector('[data-sg-grid]');

  // ── カードの画像送り（先方シート No.55）──────────────
  // 検索結果などの標準カード（snippets/card-gallery.liquid）と同じく、画像の左右に矢印を出して
  // 送れるようにする。母集合には画像を1枚目と枚数しか入れていないので、
  // 矢印が初めて押されたときに `?view=sgimages`（templates/product.sgimages.liquid）で取る。
  // 初期描画（Liquid）のカードも同じ形で出しているので、どちらもここで拾う。
  var SG_ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">'
    + '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>';
  function sgMediaHtml(p){
    var img = p.image
      ? '<img class="sg-card__img" loading="lazy" src="' + p.image + '" alt="">'
      : '<span class="sg-card__img"></span>';
    if (!p.image || !(p.imageCount > 1)) return img;
    return '<div class="sg-card__media" data-sg-media="' + p.handle + '">' + img
      + '<button type="button" class="sg-card__arrow sg-card__arrow--prev" data-sg-step="-1" aria-label="前の画像"><span class="sg-card__arrow-icon">' + SG_ARROW_SVG + '</span></button>'
      + '<button type="button" class="sg-card__arrow sg-card__arrow--next" data-sg-step="1" aria-label="次の画像"><span class="sg-card__arrow-icon">' + SG_ARROW_SVG + '</span></button>'
      + '</div>';
  }
  var SG_IMAGES = {};
  // 取れた画像リスト（スワイプ中に隣の画像を同期で出すため、Promise とは別に持つ）
  var SG_LIST = {};
  function sgImages(handle){
    if (!SG_IMAGES[handle]) {
      SG_IMAGES[handle] = fetch('/products/' + handle + '?view=sgimages')
        .then(function(r){ if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function(d){ return (SG_LIST[handle] = (d && d.images) || []); })
        // 失敗は覚えない。次に押したときに取り直す
        .catch(function(){ delete SG_IMAGES[handle]; return null; });
    }
    return SG_IMAGES[handle];
  }
  if (gridEl) gridEl.addEventListener('click', function(e){
    var btn = e.target.closest('.sg-card__arrow');
    if (!btn || !gridEl.contains(btn)) return;
    // 矢印はカードのリンク（<a class="sg-card">）の中にある。押しても商品ページへ飛ばさない
    e.preventDefault();
    e.stopPropagation();
    sgStepMedia(btn.closest('[data-sg-media]'), Number(btn.getAttribute('data-sg-step')) || 1);
  });
  function sgStepMedia(media, step){
    var img = media && media.querySelector('img.sg-card__img');
    if (!img) return;
    sgImages(media.getAttribute('data-sg-media')).then(function(list){
      if (!list || list.length < 2 || !media.isConnected) return;
      var cur = Number(media.getAttribute('data-sg-index') || 0);
      var next = (cur + step + list.length) % list.length;
      media.setAttribute('data-sg-index', String(next));
      img.src = list[next];
      sgWarmAround(media, list);
    });
  }

  // ── スワイプで画像送り（No.114）──────────────────
  // スマホは矢印を出さない（CSS の max-width: 749px）ので、画像を左右にスワイプして送る（先方依頼 10/5）。
  // 指の動きに合わせて今の画像と隣の画像をずらし、離したら隣の画像まで滑らせて入れ替える。
  // 動き始めの 8px で横か縦かを決め、縦ならブラウザのスクロールに任せる（.sg-card__media は touch-action: pan-y）。
  // 横に 30px 以上（すばやく払ったときは 15px 以上）動かしたら送る。足りなければ元の位置に戻す。
  // 画像リストがまだ取れていないときは今の画像だけを重めに動かし、送るときは従来どおり差し替える。
  // 横に動かしたあとに来るクリックは商品ページへの遷移にしない。
  var SG_SWIPE_MIN = 30;
  var SG_FLICK_MIN = 15;
  var SG_FLICK_MS = 250;
  var SG_LOCK_PX = 8;
  var SG_SLIDE_MS = 250;
  var sgTouch = null;
  var sgSwipedAt = 0;
  function sgSide(media, list, idx, pos){
    var im = document.createElement('img');
    im.className = 'sg-card__img sg-card__img--side';
    im.alt = '';
    im.decoding = 'async';
    im.src = list[idx];
    im.style.left = pos;
    media.appendChild(im);
    return im;
  }
  function sgDragStart(t){
    var media = t.media;
    var list = SG_LIST[media.getAttribute('data-sg-media')];
    t.img = media.querySelector('img.sg-card__img:not(.sg-card__img--side)');
    if (!t.img) return false;
    if (list && list.length > 1) {
      var n = list.length;
      var cur = Number(media.getAttribute('data-sg-index') || 0);
      t.list = list;
      t.cur = cur;
      t.prev = sgSide(media, list, (cur - 1 + n) % n, '-100%');
      t.next = sgSide(media, list, (cur + 1) % n, '100%');
    }
    media.classList.add('is-dragging');
    return true;
  }
  function sgDragTo(t, dx, ms){
    var els = [t.img, t.prev, t.next];
    // リストが無いときは隣が出せないので、今の画像だけを重めに動かす
    var x = t.list ? dx : dx * 0.35;
    els.forEach(function(el){
      if (!el) return;
      el.style.transition = ms ? 'transform ' + ms + 'ms ease-out' : 'none';
      el.style.transform = 'translateX(' + x + 'px)';
    });
  }
  function sgDragEnd(t, step){
    var media = t.media;
    var w = media.clientWidth;
    function cleanup(){
      if (t.prev && t.prev.parentNode) t.prev.remove();
      if (t.next && t.next.parentNode) t.next.remove();
      t.img.style.transition = '';
      t.img.style.transform = '';
      media.classList.remove('is-dragging');
    }
    if (!step || !t.list) {
      sgDragTo(t, 0, SG_SLIDE_MS);
      setTimeout(function(){
        cleanup();
        if (step) sgStepMedia(media, step);
      }, SG_SLIDE_MS);
      return;
    }
    var n = t.list.length;
    var nextIdx = (t.cur + step + n) % n;
    var incoming = step > 0 ? t.next : t.prev;
    sgDragTo(t, step > 0 ? -w : w, SG_SLIDE_MS);
    setTimeout(function(){
      if (!media.isConnected) return;
      // 入ってきた画像をそのまま今の画像にする（src の差し替えでちらつかせない）
      t.img.remove();
      incoming.classList.remove('sg-card__img--side');
      incoming.style.left = '';
      incoming.style.transition = '';
      incoming.style.transform = '';
      if (incoming === t.next) t.next = null; else t.prev = null;
      if (t.prev) t.prev.remove();
      if (t.next) t.next.remove();
      media.classList.remove('is-dragging');
      media.setAttribute('data-sg-index', String(nextIdx));
      sgWarmAround(media, t.list);
    }, SG_SLIDE_MS);
  }
  if (gridEl) {
    gridEl.addEventListener('touchstart', function(e){
      var media = e.target.closest('[data-sg-media]');
      if (!media || e.touches.length !== 1 || media.classList.contains('is-dragging')) { sgTouch = null; return; }
      sgTouch = { media: media, x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), lock: null };
      // 先読みがまだ届いていなくても、触った時点で画像リストを取りに行く
      sgImages(media.getAttribute('data-sg-media'));
    }, { passive: true });
    gridEl.addEventListener('touchmove', function(e){
      var t = sgTouch;
      if (!t || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - t.x;
      var dy = e.touches[0].clientY - t.y;
      if (!t.lock) {
        if (Math.abs(dx) < SG_LOCK_PX && Math.abs(dy) < SG_LOCK_PX) return;
        if (Math.abs(dx) <= Math.abs(dy)) { sgTouch = null; return; }
        if (!sgDragStart(t)) { sgTouch = null; return; }
        t.lock = 'x';
      }
      t.dx = dx;
      sgDragTo(t, dx, 0);
    }, { passive: true });
    gridEl.addEventListener('touchend', function(){
      var t = sgTouch;
      sgTouch = null;
      if (!t || t.lock !== 'x') return;
      sgSwipedAt = Date.now();
      var dx = t.dx || 0;
      var quick = Date.now() - t.t < SG_FLICK_MS;
      var far = Math.abs(dx) >= SG_SWIPE_MIN || (quick && Math.abs(dx) >= SG_FLICK_MIN);
      // 左へスワイプ＝次の画像、右へ＝前の画像
      sgDragEnd(t, far ? (dx < 0 ? 1 : -1) : 0);
    }, { passive: true });
    gridEl.addEventListener('touchcancel', function(){
      var t = sgTouch;
      sgTouch = null;
      if (t && t.lock === 'x') sgDragEnd(t, 0);
    }, { passive: true });
    gridEl.addEventListener('click', function(e){
      if (Date.now() - sgSwipedAt > 500) return;
      if (!e.target.closest('[data-sg-media]')) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  // ── 先読み（押してから待たせない）──────────────────
  // 初回のクリックは「画像リスト 約250ms ＋ 画像 350〜480ms」待っていた（2026-09-30 実測）。
  // 全商品の全画像を先に落とすと 48枚×約9枚×約50KB＝約20MB になるので、**画面に出たカードだけ**、
  // 画像リストと「次・前の1枚」を先に読む。送るたびにその先の1枚をまた読む（1カード 約100KB）。
  // 画像リストの取得は同時2本まで。スクロールで一瞬通り過ぎたカードは読まない（200ms 留まったら）。
  // ストアフロントは短時間に叩きすぎると待機ページを返すので、ここを雑に並列にしないこと。
  // 始めるのは初期表示（window load）が終わってから。
  var SG_WARM = {};
  function sgWarm(url){
    if (!url || SG_WARM[url]) return;
    SG_WARM[url] = 1;
    var im = new Image();
    im.decoding = 'async';
    im.src = url;
  }
  function sgWarmAround(media, list){
    var n = list.length;
    if (n < 2) return;
    var cur = Number(media.getAttribute('data-sg-index') || 0);
    sgWarm(list[(cur + 1) % n]);
    sgWarm(list[(cur - 1 + n) % n]);
  }
  var SG_QUEUE = [];
  var SG_ACTIVE = 0;
  var SG_MAX_ACTIVE = 2;
  function sgPrefetch(media){
    SG_ACTIVE++;
    sgImages(media.getAttribute('data-sg-media')).then(function(list){
      if (list && list.length > 1 && media.isConnected) sgWarmAround(media, list);
    }).then(function(){
      SG_ACTIVE--;
      sgPump();
    });
  }
  function sgPump(){
    while (SG_ACTIVE < SG_MAX_ACTIVE && SG_QUEUE.length) {
      var media = SG_QUEUE.shift();
      if (media.isConnected) sgPrefetch(media);
    }
  }
  var SG_IO = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      var m = en.target;
      if (en.isIntersecting) {
        m.__sgTimer = setTimeout(function(){
          SG_IO.unobserve(m);
          SG_QUEUE.push(m);
          sgPump();
        }, 200);
      } else {
        clearTimeout(m.__sgTimer);
      }
    });
  }, { rootMargin: '100px 0px' }) : null;
  var SG_WARM_READY = false;
  // グリッドを描き直したら呼ぶ（renderResults() の末尾）。描き直しで入れ替わったカードも拾う
  function sgObserveCards(){
    if (!SG_IO || !SG_WARM_READY || !gridEl) return;
    gridEl.querySelectorAll('[data-sg-media]').forEach(function(m){
      if (m.__sgObserved) return;
      m.__sgObserved = true;
      SG_IO.observe(m);
    });
  }
  function sgStartWarm(){
    SG_WARM_READY = true;
    sgObserveCards();
  }
  if (document.readyState === 'complete') setTimeout(sgStartWarm, 300);
  else window.addEventListener('load', function(){ setTimeout(sgStartWarm, 300); });
  var countEl = resultsWrap.querySelector('[data-sg-count]');
  var chipsEl = resultsWrap.querySelector('[data-sg-chips]');
  var emptyEl = resultsWrap.querySelector('[data-sg-empty]');
  var moreEl = resultsWrap.querySelector('[data-sg-more]');
  var moreBtn = resultsWrap.querySelector('[data-sg-more-btn]');
  var qEl = resultsWrap.querySelector('[data-sg-q]');
  var qClearEl = resultsWrap.querySelector('[data-sg-q-clear]');
  var qStatusEl = resultsWrap.querySelector('[data-sg-search-status]');
  var USER_TYPED_QUERY = false;
  var sortEl = resultsWrap.querySelector('[data-sg-sort]');
  // 商品名検索の入力値。検索ページの検索語（上の QUERY）とは別物なので名前を分ける。
  // ⚠️ **正規化した後の文字列**を入れる（生の入力ではない）。素の一覧側
  // （snippets/collection-text-filter.liquid）と同じ土俵に乗せないと、同じ語を
  // 打っても片方だけ 0 件になる。生の入力が要る場所（URL への書き戻し）は
  // qEl.value を直接読むこと。
  var TEXT_Q = '';
  // TEXT_Q を空白で割った語の配列。検索は **語ごとの AND**（素の一覧側と同じ）。
  // 1本の文字列のまま indexOf すると「ラシッサ 引戸」が連続部分一致を要求して
  // しまい、本来 1,314 件あるのに 0 件になる（issue #801）。
  var TEXT_Q_TERMS = [];
  var Q_PARAM = 'filter.q';   // 素の一覧側の従来のパラメータ名に合わせる

  // ---- 検索語の正規化 -----------------------------------------------------
  // 打ち手の入力と商品側のテキスト（searchText）は、**同じ1本の関数**で畳んでから
  // 突き合わせる。実体は下の normText()（関数宣言なのでここから呼べる）。
  // ここに別実装を置かないこと。以前は入力側だけ自前の半角カナ表で畳んでいて、
  // 商品側の NFKC と食い違い、全角英数で打った SKU（`ＬＶ０１ＡＮ－ＬＡＡ`）が
  // 素の一覧側では引けるのにガイド側だけ 0 件になっていた。

  // 商品名検索の語を入れ替える。TEXT_Q と TEXT_Q_TERMS は必ず一緒に動かす
  // （片方だけ更新すると、窓は空なのに絞り込みだけ残るような食い違いになる）。
  //
  // **商品名の索引**（assets/facet-text-<handle>.json / scripts/bake_facet_from_bulk.py）。
  // 絞り込みの索引（facet-index）と**同じ並び**の配列で、各行は商品名・メーカー・
  // 商品タイプ・SKU を1本にした検索用の文字列。検索語を最初に入れたときに1回だけ読み、
  // 全件をブラウザで照合する。
  // 母集合（全ページ取得）で照合していた頃は、40ページ（10,000件）で打ち止めになる
  // 大きいコレクションで全体の約半分しか検索対象に入らず、件数が永久に確定しなかった
  // （sash-window で「インプラス」: 読めた範囲だけ／bulk 照合では 1,609件 / issue #848）。
  // ⚠️ 無い・読めない・行数が索引と合わないときは TEXT_FAILED を立て、従来どおり
  // 母集合で照合する（ensureDisplayPool）。
  var TEXT_ROWS = null;     // 検索用の文字列の配列（normText 済み）。索引の行と同じ添字
  var INDEX_VALS_RAW = null;
  var TEXT_LOAD = null;     // 読み込みの Promise。2回目以降は同じものを返す
  var TEXT_FAILED = false;  // 読めなかった＝従来経路
  var TEXT_READY = false;   // INDEX_ROWS の各行に _ntext を貼り終えた＝件数は索引だけで確定する

  function setTextQuery(raw){
    TEXT_Q = normText(raw);
    TEXT_Q_TERMS = TEXT_Q ? TEXT_Q.split(/\s+/).filter(Boolean) : [];
    if (!TEXT_Q) return;
    // ⚠️ **全件の母集合ではなく商品名の索引を読む。** `?filter.q=` からの復元もここを
    // 通るので、打鍵と復元の両方がこの1行で担保される。
    // 読めなかったときだけ従来どおり全件の表示項目を取りに行く（#801 の経路）。
    loadTextIndex().then(function(rows){
      if (!rows) { ensureDisplayPool(); return; }
      if (!attachTextIndex()) return;       // 絞り込みの索引がまだ＝useIndex() が貼る
      afterTextIndex();
    });
  }
  var layoutEl = resultsWrap.querySelector('.sg-layout');
  var filterOpenBtn = resultsWrap.querySelector('[data-sg-filter-open]');
  var filterBadge = resultsWrap.querySelector('[data-sg-filter-badge]');

  var NUM_AX = { 'W': 1, 'H': 1 };
  var data, axes = [], selections = {}, flat = false;
  // 1ページ目だけで描いている途中かどうか。件数はサーバの総数を出し続ける
  // （途中の母集合で数えると「250件」のような嘘の数が一瞬見える）。
  var PARTIAL = false;
  // 母集合がHTMLに埋め込まれていたか。埋め込み＝全件なので取得も刻みも要らない。
  var INLINE_USED = false;
  // 焼き込んだ軸（scripts/bake_facet_axes.py がコレクションのメタフィールドへ入れる）。
  // 251件以上のページは母集合を全ページ取り終わるまで軸が立たなかった。
  // 実測 /collections/sash-window で 40リクエスト・10.2MB・15.4秒。
  // 焼き込みは「軸 -> 生値 -> 件数」の集計で、**選択が空のあいだは各選択肢の
  // 残N件がこの集計そのもの**（母数が全体だから）。つまり初期表示はネットワーク0で正しい。
  //
  // ⚠️ 正典ではない。母集合が揃ったら activate() が組み直して上書きする。
  // だから焼き込みが古くても最終的に必ず正しい値へ収束する。
  // 焼き込みで描いているあいだは URL を書き換えない。
  // render() の末尾は writeQuery() を通るので、`?f.窓種類=すべり出し窓` 付きで
  // 開かれたページだと、選択を復元する前（seedFromQuery は母集合が揃ってから）に
  // **URL のパラメータを消してしまう**。消えると復元先が無くなる。
  var SUPPRESS_QUERY_WRITE = false;
  var DIGEST = null;          // 焼き込みそのもの
  var DIGEST_COUNTS = null;   // 軸 -> { 値: 件数 }（バケット化・価格帯まで済ませたもの）
  var POOL_FULL = false;      // 母集合を全部持っているか（埋め込み or 全ページ取得済み）
  // 選択を受け付けてよいか。焼き込みで軸を描いた直後は false（商品がまだ無い）。
  // activate() が母集合で組み直したときに true になる＝従来と同じタイミング。
  var INTERACTIVE = false;
  function setLocked(locked){
    INTERACTIVE = !locked;
    root.setAttribute('data-sg-locked', locked ? 'true' : 'false');
  }
  // 何件まで描いてあるか。ネイティブ一覧を隠している以上ページングは自前で持つ。
  // 未選択の L1（761件）を一度に innerHTML すると DOM が重すぎる。
  var shown = 0;

  // 上部ウィザードで何ステップまで開示済みか。上部の操作だけが進める。
  // 左サイドで選んでも進めない＝上部アコーディオンを自動展開させない（issue #154）
  var stepCursor = 0;

  // selections[ax] = 選択値の配列（軸内OR）。空/未定義=未選択。
  function sel(ax){ return selections[ax] || []; }

  // ---- URL との同期 -----------------------------------------------------
  // ?f.<軸名>=<値> で絞り込み状態を表す。同じキーの繰り返し=軸内OR / 別キー=軸間AND。
  // Shopify の filter.p.* と同じ読み方になる。第1階層のガイドからここへ誘導するため、
  // また共有リンク・広告のランディング・リロード耐性のために必要。
  var QUERY_PREFIX = 'f.';

  // ---- メーカーの固定 ------------------------------------------------------
  // 旧タグURL（`/collections/<カテゴリ>/maker:lixil`）で開いたときは、そのメーカーを
  // **利用者の選択（selections）とは別に**持ち、matches() で常に掛ける（issue #595）。
  // selections に入れると、結果バーの「すべて解除」・サイドの「クリア」・上部パンくずの
  // 「すべて解除」・チップの✕がそれぞれ selections を捨てるので、1経路でも直し漏れると外れる。
  // メーカーの軸を出さない一覧（網戸など）でも効く。軸に出すかどうかと関係なく、
  // 商品行の v にはタグのメーカーをそのまま入れているため。
  // 自社オリジナルだけはメーカーのタグではなく `series:kantan-tategu` で絞る。
  var PIN = (function(){
    // current_tags は URL から来る。`</script>` で抜けられないよう、セクション側で `<` を逃がしてから渡している
    var tags = currentTags || [];
    for (var i = 0; i < tags.length; i++){
      var t = String(tags[i]), j = t.indexOf(':');
      if (j < 0) continue;
      var k = t.slice(0, j).trim(), v = t.slice(j + 1).trim();
      if (k === 'maker' && v) return { ax: k, v: v };
      if (k === 'series' && v === 'kantan-tategu') return { ax: k, v: v };
    }
    return null;
  })();
  function pinHit(p){
    var mine = p.v[PIN.ax];
    return !!mine && mine.indexOf(PIN.v) >= 0;
  }

  function readQuery(){
    var out = {}, params = new URLSearchParams(location.search);
    params.forEach(function(value, key){
      if (key.indexOf(QUERY_PREFIX) !== 0 || !value) return;
      var ax = key.slice(QUERY_PREFIX.length);
      (out[ax] = out[ax] || []).push(value);
    });
    return out;
  }

  // 軸と値を実データと突き合わせて、存在しないものは捨てる。
  // 商品が入れ替わった後の古いリンクで「0件だが解除もできない」状態を作らないため。
  function seedFromQuery(){
    var wanted = readQuery(), lastIdx = -1, applied = false;
    for (var i = 0; i < axes.length; i++){
      var ax = axes[i], asked = wanted[ax.key];
      if (!asked) continue;
      // 固定したメーカーの軸は URL の `?f.maker=` で上書きさせない（重ねると0件になる）
      if (PIN && ax.key === PIN.ax) continue;
      // 実寸（`=1694`）は ax.values に無いので、刻みを持つ軸なら数値として読めれば受ける
      var known = asked.filter(function(v){
        return ax.values.indexOf(v) >= 0 || (isFine(v) && !!fineOf(ax.key, v.slice(1)));
      });
      if (!known.length) continue;
      selections[ax.key] = known;   // step も flat と同じく軸内の複数値を復元する（#938）
      lastIdx = i;
      applied = true;
    }
    // 選択済みのステップは開いた状態で見せる
    if (!flat && lastIdx >= 0) stepCursor = lastIdx + 1;
    return applied;
  }

  // 切り口（「レイアウトから選ぶ」など）から来たときは結果まで送る。
  // 「壁付I型」は専用コレクションが無く、同じページに ?f.レイアウト=壁付I型 が
  // 付くだけなので、上に着地したままだと**何も起きていないように見える**。
  function scrollToResults(){
    if (!resultsWrap || resultsWrap.hidden) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // レイアウト確定後に測る。画像の読み込みで位置がずれるため2フレーム待つ。
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        resultsWrap.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  // URL から選択と商品名検索を復元する。**通すのは1回だけ。**
  //
  // ⚠️ 索引が先に届く経路（useIndex）と母集合が届く経路（activate）の両方から呼ばれる。
  // 2回通すと scrollToResults() が2回走り、カードを見ている最中に引き戻される。
  //
  // ⚠️ **索引経路からも必ず通す。** activate() の索引 early return がここを飛ばすと、
  // 索引を持つ86コレクションでは `?f.<軸>=<値>` と `?filter.q=` が一切復元されない。
  // writeQuery() は選択のたびに URL を書き続けるので、共有リンク・リロード・戻る操作で
  // 「URL にパラメータが載っているのに画面は未絞り込み」になる。
  var QUERY_SEEDED = false;
  function restoreFromQuery(){
    if (QUERY_SEEDED) return false;
    QUERY_SEEDED = true;
    // ⚠️ 母集合を待たずに押せるので、押した結果は writeQuery() で URL に入る。
    // そのあと同じ値を読んで「URLから来た」と誤認しないよう、自分で押していたら復元扱いにしない。
    var seeded = seedFromQuery() && !USER_PICKED;
    // `?filter.q=` で来た場合は商品名検索も復元する
    if (qEl && !USER_TYPED_QUERY){
      var q0 = new URLSearchParams(location.search).get(Q_PARAM) || '';
      if (q0){
        qEl.value = q0;
        setTextQuery(q0);
        if (qClearEl) qClearEl.hidden = false;
        seeded = true;
      }
    }
    return seeded;
  }

  // 現在の選択を URL に書き戻す。f. 以外のパラメータ（preview_theme_id など）は残す。
  // pushState ではなく replaceState: 選択ごとに履歴が積まれると戻るボタンが使えなくなる。
  function writeQuery(){
    if (SUPPRESS_QUERY_WRITE) return;
    if (!history.replaceState) return;
    var params = new URLSearchParams(location.search), keep = [];
    params.forEach(function(value, key){
      if (key.indexOf(QUERY_PREFIX) !== 0) keep.push([key, value]);
    });
    var next = new URLSearchParams();
    keep.forEach(function(kv){ next.append(kv[0], kv[1]); });
    axes.forEach(function(ax){
      sel(ax.key).forEach(function(v){ next.append(QUERY_PREFIX + ax.key, v); });
    });
    var qs = next.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }
  function selectedCount(){ return axes.filter(function(a){ return sel(a.key).length; }).length; }
  // optCount は activeAxes から呼ばれるので、定義順の都合で前方参照になる（関数宣言なので問題ない）
  // いまの選択のもとで「選べる値がひとつでもある」軸だけを出す。
  // これが無いと行き止まりのステップが出る:
  //   フーゴで 駐車台数=1台＋二輪車 を選ぶと、合掌（Y/M）を持つ商品が1件も無くなり、
  //   ステップ4に「M合掌 0件 / Y合掌 0件」だけが並んで先に進めなくなっていた。
  // 選択済みの軸は、解除できるように必ず残す。
  // 少なくとも1つの選択肢が「母数を MIN_SPLIT 以上減らす」ことを求める。
  // 選択肢が多い軸（幅など）は小さい値が必ずあるので当然通る。引っかかるのは
  // 「値が2つしかなく、どちらもほぼ全件」という実質1択の軸だけ。
  // その軸でいま並べる選択肢。ふだんは ax.values（刻み）。
  // 刻みを持つ寸法の軸で、ほかの軸で絞り込んだ残りの実寸が FINE_MAX 種類以下かつ
  // 刻みより細かく分けられるときだけ、実寸（`=1694`）を並べる。
  // 刻みの値を選んでいる間は刻みのまま、実寸を選んでいる間は実寸のまま（解除できるように）。
  // 焼き込みの集計をそのまま使う初期表示（digestUsable）は実寸を持たないので刻みのまま。
  // 区分（ranges）の軸は対象外。fineOf が実寸を作らないので fv が空になり、区分のまま並ぶ。
  // 区分の軸は件数0の選択肢（その他・指定なしを含む）を外す（#957）。選択中の値は解除できるように残す。
  // ⚠️ 残N件が確定していないあいだは外さない（1ページ目を母数にした 0 は嘘）。
  // 確定かどうかは invalidate() を伴わずに変わる経路がある（clearServerRows など）ので、
  // fineCache には載せず毎回見る。件数は countsFor() のキャッシュなので重くない。
  function axValues(ax){
    var list = axValuesRaw(ax);
    if (!rangesOf(ax.key) || !countsAreExact(ax.key)) return list;
    var counts = countsFor(ax.key), picked = sel(ax.key);
    return list.filter(function(v){ return counts[v] > 0 || picked.indexOf(v) >= 0; });
  }
  function axValuesRaw(ax){
    if (!isBucketed(ax.key)) return ax.values;
    ensureCache();
    if (fineCache.hasOwnProperty(ax.key)) return fineCache[ax.key] || ax.values;
    var fine = null, picked = sel(ax.key);
    var pickedFine = picked.some(isFine);
    var pickedBucket = picked.some(function(v){ return !isFine(v) && v !== NONE_VALUE; });
    // 何も選んでいない初期表示は刻みのまま（ほかの軸で絞り込んだときだけ実寸にする）
    var narrowed = selList().some(function(s){ return s.k !== ax.key; });
    if (!pickedBucket && (pickedFine || narrowed) && !digestUsable(ax.key)){
      var counts = countsFor(ax.key);
      var fv = Object.keys(counts).filter(function(v){ return isFine(v) && counts[v] > 0; });
      picked.forEach(function(v){ if (isFine(v) && fv.indexOf(v) < 0) fv.push(v); });
      var buckets = ax.values.filter(function(v){ return v !== NONE_VALUE && counts[v] > 0; }).length;
      if (pickedFine || (fv.length >= 2 && fv.length <= FINE_MAX && fv.length > buckets)){
        fv.sort(function(a, b){
          var x = numRange(a.slice(1)), y = numRange(b.slice(1));
          return (x[0] - y[0]) || (x[1] - y[1]);
        });
        if (ax.values.indexOf(NONE_VALUE) >= 0) fv.push(NONE_VALUE);
        fine = fv;
      }
    }
    fineCache[ax.key] = fine;
    return fine || ax.values;
  }

  function splitsEnough(ax, base){
    var limit = base * (1 - MIN_SPLIT);
    var list = axValues(ax);
    for (var i = 0; i < list.length; i++){
      var v = list[i];
      if (v === NONE_VALUE) continue;
      var c = optCount(ax.key, v);
      if (c > 0 && c <= limit) return true;
    }
    return false;
  }

  // 1回の再描画で render / renderSide / renderResults / axIndex から呼ばれるので、
  // 同じ世代のあいだは結果を使い回す（中身は軸数×選択肢数の走査で重い）。
  function activeAxes(){
    ensureCache();
    if (activeCache) return activeCache;
    activeCache = axes.filter(function(ax){
      // 固定したメーカーの軸は出さない。出すと他メーカーを選べてしまい、固定と重ねて0件になる
      if (PIN && ax.key === PIN.ax) return false;
      // 定義モード: 定義に書いた軸は選択の途中でも落とさない（選べない選択肢は data-sg-zero でグレー）
      if (DEF) return true;
      if (sel(ax.key).length) return true;
      var base = baseSize(ax.key);
      if (!base) return false;
      var any = false, discriminates = false, none = 0;
      var list = axValues(ax);
      for (var i = 0; i < list.length; i++){
        var v = list[i], c = optCount(ax.key, v);
        if (v === NONE_VALUE) { none = c; continue; }
        if (c > 0) any = true;
        if (c > 0 && c < base) discriminates = true;
      }
      // 全部0 … 行き止まり（選べる値が無い）
      if (!any) return false;
      // 全部が母数と同じ … 選んでも減らない
      //   （L4のページで「シリーズ」に自分と親の2つが並び、どちらも全件になる例）
      if (!discriminates) return false;
      // **どれを選んでもほとんど減らない軸**も落とす。上の discriminates は
      // 「1件でも減れば通る」ので、フーゴ（2,086件）の「シリーズ」が
      // `fuugo` 2,086 / `kaapooto` 2,070 で生き残り、押しても16件しか減らない
      // ステップが先頭に出ていた。
      if (MIN_SPLIT > 0 && !splitsEnough(ax, base)) return false;
      // **いまの選択のもとでのカバー率**が低い軸は出さない。
      // これで「特定の条件のときだけ出る軸」が自然に実現する:
      //   ハンドル種類は すべり出し窓 にしか付かないので、窓のタイプを選ぶ前は出ず、
      //   「すべり出し窓」を選んだ瞬間に出てくる（先方のご指摘「すべり出し窓が対象」）。
      // 判定を選択のたびにやり直すのが肝。コレクション全体で1回だけ見ると実現しない。
      return (base - none) / base >= MIN_COVERAGE;
    });
    return activeCache;
  }
  function axIndex(key){
    var vis = activeAxes();
    for (var i = 0; i < vis.length; i++){ if (vis[i].key === key) return i; }
    return -1;
  }

  function yen(v){ if(v==null||v==='') return ''; return '¥' + Math.round(parseFloat(v)).toLocaleString('ja-JP'); }

  // 値の表示名。生成側が labels を持たせていればそれを使う
  // （maker: lixil→LIXIL / series: saamosu-l→サーモスL / W: 1600-1799→1600〜1799mm）。
  // 無ければ従来どおり W/H のバケット表記だけ整形する。
  function axByKey(k){
    for (var i = 0; i < axes.length; i++){ if (axes[i].key === k) return axes[i]; }
    return null;
  }
  function yenLabel(n){
    if (n >= 10000) {
      var man = n / 10000;
      return (Math.round(man * 10) / 10) + '万円';
    }
    return n.toLocaleString() + '円';
  }
  function dispVal(ax, v){
    if (v === NONE_VALUE) return NONE_LABEL;
    if (isFine(v)){
      // 実寸。`=1694` → 1694mm / `=451-550` → 451〜550mm / 間口 `=90` → 90cm
      var unit = UNITS[ax] || 'mm';
      return v.slice(1).replace(/^(\d+(?:\.\d+)?)-(\d+(?:\.\d+)?)$/, '$1〜$2') + unit;
    }
    var vm = vmeta(ax, v);
    if (vm && vm.l) return vm.l;      // 「絞り込み値」の表示名が最優先
    if (ax === PRICE_AXIS){
      var m = String(v).match(/^(\d+)-(\d*)$/);
      if (m){
        var lo = parseInt(m[1], 10), hi = m[2] ? parseInt(m[2], 10) + 1 : null;
        if (lo === 0) return yenLabel(hi) + '未満';
        if (hi === null) return yenLabel(lo) + '以上';
        return yenLabel(lo) + '〜' + yenLabel(hi);
      }
    }
    // 定義モードの list: 表示名を定義に書いていなければ値そのまま（共通の表示名・単位の補完は使わない）
    if (DEF && defIsList(ax)) return v;
    var a = axByKey(ax);
    if (a && a.labels && a.labels[v]) return a.labels[v];
    return NUM_AX[ax] ? v.replace(/^(\d+)-(\d+)$/, '$1〜$2mm') : v;
  }

  // 選択肢の表示名を HTML に差し込むときの形。定義モードは表示名をエスケープする
  // （定義の label は運用者が表に書いた文字列で、HTML として読ませない）。
  // 説明（vm.d）は従来どおり HTML のまま。レガシーは従来どおりエスケープしない。
  function escHtml(s){
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function dispHtml(ax, v){ return DEF ? escHtml(dispVal(ax, v)) : dispVal(ax, v); }

  // 現在の選択(exceptAxisを除く)にマッチする商品（軸間AND・軸内OR）
  // 商品名の部分一致。**軸の件数計算にも通す**ので、検索中は各選択肢の件数も
  // 検索後の母数で出る（「押したら0件」を作らない）。
  // ⚠️ **表示に使う項目は行そのものが持っていないことがある。**
  // 索引から組んだ行（rowsFromIndex）はハンドル・価格・軸の値しか持たず、
  // タイトル・公開日・検索用テキストは別経路（母集合・タグ取得）で届いて
  // DISPLAY に入る。タイトル等を読むときは必ずここを通す。
  // 通さないと `undefined` を並べたり、商品名検索が全件0件になったりする。
  function dsp(p){ return (p && DISPLAY[p.handle]) || p; }

  function matchesQuery(p){
    if (!TEXT_Q_TERMS.length) return true;
    var d = dsp(p);
    // 正規化済みの検索用テキストは行ごとに1回だけ作って持たせる。matchesQuery は
    // 1回の再描画で数十万回走るので、毎回 replace を掛けると描画が秒単位で伸びる。
    // rememberDisplay() は DISPLAY の行を**丸ごと差し替える**（searchText を
    // その場で書き換えない）ので、この覚え書きが古いまま残ることはない。
    // 商品名の索引が貼れていれば（attachTextIndex）行そのものが持つ `_ntext` で照合する。
    // DISPLAY の有無に関係なく全件が同じ土俵に乗るので、件数が取得の進み具合で動かない。
    // ⚠️ DISPLAY 側（タグ込み）と混ぜないこと。混ぜると絵が届いた商品だけタグで当たり、
    // 件数が届くたびに増える。
    var hay = p._ntext;
    if (hay === undefined) hay = d._nsearch;
    if (hay === undefined) hay = d._nsearch = normText(d.searchText || '');
    // **語ごとの AND**。素の一覧側（collection-text-filter.liquid の terms.every）
    // と同じ規則。1語でも欠けたら落とす。
    for (var i = 0; i < TEXT_Q_TERMS.length; i++){
      if (hay.indexOf(TEXT_Q_TERMS[i]) < 0) return false;
    }
    return true;
  }

  // ---- 1回の再描画ぶんのキャッシュ ---------------------------------------
  // 絞り込みの結果は「選択（selections）＋商品名検索（TEXT_Q）＋母集合（data.products）」
  // だけで決まる。ところが1回の render() は同じ計算を何度もやり直していた:
  //
  //   activeAxes()  … render / renderSide / renderResults / axIndex から都度呼ばれる
  //   optCount()    … 呼ばれるたび data.products を2回 filter する
  //                   → 軸数 × 選択肢数 × 商品数
  //
  // 窓・シャッター（19,559商品 / 11軸 / 170選択肢）で実測すると、チェックを1つ
  // 付けるだけで **配列要素 1,762万件・全件スキャン 840回**を走っていた（JS 1.0〜1.6秒）。
  //
  // なので世代番号で束ねて、同じ世代の中では使い回す。選択が変わったら
  // invalidate() で世代を進める（= 全部捨てる）。
  var CACHE_GEN = 0, cacheGenAt = -1;
  var baseCache = null;      // 軸キー -> その軸を除いた母集合（配列）
  var countCache = null;     // 軸キー -> { 選択肢: 件数 }
  var activeCache = null;    // activeAxes() の結果
  var selCache = null;       // 選択中の軸だけを畳んだ配列
  var fineCache = {};        // 軸 -> 実寸で並べる選択肢（null は刻みのまま）。axValues()

  function invalidate(){ CACHE_GEN++; }

  function ensureCache(){
    if (cacheGenAt === CACHE_GEN) return;
    cacheGenAt = CACHE_GEN;
    baseCache = {};
    countCache = {};
    activeCache = null;
    selCache = null;
    fineCache = {};
  }

  // 選択中の軸だけを配列に畳む。matches() は1回の再描画で数十万回走るので、
  // そのたびに for-in で未選択の軸まで見に行かないようにする。
  function selList(){
    ensureCache();
    if (selCache) return selCache;
    var out = [];
    for (var ax in selections){
      var vals = selections[ax];
      if (!vals || !vals.length) continue;
      out.push({ k: ax, vals: vals, none: vals.indexOf(NONE_VALUE) >= 0 });
    }
    selCache = out;
    return out;
  }

  function matches(p, exceptAxis){
    // 固定したメーカーは exceptAxis でも外さない（どの軸の残N件も、そのメーカーの中で数える）
    if (PIN && !pinHit(p)) return false;
    if (!matchesQuery(p)) return false;
    var list = selList();
    // 除外タグ付きの行（build() が x を付けて残す）は、未選択の一覧にだけ出す。
    // 軸を1つでも選んだら結果から外す。商品名検索だけのときは残す（名前で探した商品は消さない）
    if (p.x && list.length) return false;
    for (var i = 0; i < list.length; i++){
      var s = list[i];
      if (s.k === exceptAxis) continue;
      // 商品側は配列。選ばれた値のどれかを持っていれば通す（軸内OR）
      var mine = p.v[s.k];
      if (!mine || !mine.length){
        if (s.none) continue;      // 「指定なし」が選ばれていれば通す
        return false;
      }
      var hit = false;
      for (var j = 0; j < mine.length && !hit; j++){ if (s.vals.indexOf(mine[j]) >= 0) hit = true; }
      if (!hit) return false;
    }
    return true;
  }

  // 「その軸を除いた」母集合。軸ごとに全件を **1回だけ** 走る。
  // exceptAxis に null を渡したものが絞り込み結果そのもの（= filtered()）。
  function baseFor(exceptAxis){
    ensureCache();
    var key = exceptAxis == null ? '' : exceptAxis;   // 軸キーに空文字は無い（build が弾く）
    var hit = baseCache[key];
    if (hit) return hit;
    var list = data.products.filter(function(p){ return matches(p, exceptAxis); });
    baseCache[key] = list;
    return list;
  }

  // その軸の全選択肢の件数を1パスで数える。
  // 以前は選択肢ごとに data.products を filter していた（軸数×選択肢数×商品数）。
  function countsFor(axKey){
    ensureCache();
    var hit = countCache[axKey];
    if (hit) return hit;
    // 母集合がまだ無くても、選択が空なら焼き込みの集計がそのまま残N件になる
    if (digestUsable(axKey)){
      countCache[axKey] = DIGEST_COUNTS[axKey] || {};
      return countCache[axKey];
    }
    var map = {}, base = baseFor(axKey);
    for (var i = 0; i < base.length; i++){
      // 絞り込み対象外（build() が x を付けた行）は一覧には残るが、軸の件数には数えない。
      // 数えると「指定なし」が膨らみ、カバー率の判定もぶれる
      if (base[i].x) continue;
      var mine = base[i].v[axKey];
      if (!mine || !mine.length){ map[NONE_VALUE] = (map[NONE_VALUE] || 0) + 1; continue; }
      for (var j = 0; j < mine.length; j++){
        // 「指定なし」は値を持たない商品の数。タグ値が偶然 __none__ でも混ぜない
        if (mine[j] === NONE_VALUE) continue;
        map[mine[j]] = (map[mine[j]] || 0) + 1;
      }
    }
    countCache[axKey] = map;
    return map;
  }

  function filtered(){ return baseFor(null); }

  // ---- 並び替え -----------------------------------------------------------
  // 標準UIの `sort_by` は素の一覧ごと隠してある（ece332a）ので、ここで受ける。
  // 母集合は手元に全件あるのでサーバへは投げ直さない。`filtered()` の結果に
  // 掛けるので、絞り込み・商品名検索とそのまま併用できる。
  // 既定の 'manual' は「取得したままの順」＝コレクションの手動並び順で、
  // 何も並べ替えない（既定で並びが変わると「壊れた」ように見える）。
  //
  // 「新着順」は出していない。母集合を供給する collection.sgdata.liquid /
  // search-products-json.liquid が日付（published_at / created_at）を返さないため、
  // 手元のデータでは新しさを判定できない。
  var SORT_DEFAULT = 'manual';
  var SORT = SORT_DEFAULT;
  // price は文字列（"12500.0"）。文字列比較すると "1000" < "900" になるので必ず数値化する
  function priceOf(p){ var n = parseFloat(p.price); return isNaN(n) ? null : n; }
  // 価格が読めない商品は昇順・降順どちらでも最後に回す（先頭を占領させない）
  function byPrice(dir){
    return function(a, b){
      var x = priceOf(a), y = priceOf(b);
      if (x === null && y === null) return 0;
      if (x === null) return 1;
      if (y === null) return -1;
      return (x - y) * dir;
    };
  }
  // 公開日は経路で形が違う。sgdata / search-products-json は
  // エポック秒の数値、products.json のフォールバックは `published_at` の
  // ISO文字列。rows.push の時点でここに通して秒の数値へ正規化する。
  // 取れないものは null にして、新着順では常に最後へ回す。
  function publishedOf(p){
    var raw = p.published;
    if (raw === undefined || raw === null || raw === '') raw = p.published_at;
    if (raw === undefined || raw === null || raw === '') return null;
    if (typeof raw === 'number') return raw > 0 ? raw : null;
    var n = parseFloat(raw);
    // "1755000000" のような数字だけの文字列はエポック秒として読む
    if (!isNaN(n) && String(raw).indexOf('-') === -1) return n > 0 ? n : null;
    var t = Date.parse(raw);
    return isNaN(t) ? null : t / 1000;
  }
  var SORTERS = {
    'price-asc':  byPrice(1),
    'price-desc': byPrice(-1),
    // 新着順は降順（新しい順）。公開日が取れない商品は最後に回す
    'newest': function(a, b){
      var x = dsp(a).published, y = dsp(b).published;
      if (x == null && y == null) return 0;
      if (x == null) return 1;
      if (y == null) return -1;
      return y - x;
    },
    // 商品名は日本語・英字・型番が混じるので localeCompare('ja')。
    // numeric を付けると「W2 < W10」のように型番の数字が数値として並ぶ。
    'title-asc':  function(a, b){
      // ⚠️ **タイトルが未着の商品は最後に回す。** 空文字は localeCompare で
      // 最小になるので、そのまま比べると骨のカードが先頭を全部占領する
      // （索引だけで絞り込める時間帯に商品名順を押すと48枚すべて骨になる）。
      // 価格が読めない商品を最後に回すのと同じ扱い。
      var x = dsp(a).title, y = dsp(b).title;
      if (!x && !y) return 0;
      if (!x) return 1;
      if (!y) return -1;
      return String(x).localeCompare(String(y), 'ja', { numeric: true });
    }
  };
  // Array.prototype.sort は破壊的。元配列（data.products も filtered() の戻りも）を
  // 直接並べ替えないよう、必ず slice() してから掛ける。
  // 'manual' のときは sort 自体を通さないので、取得順がそのまま保たれる。
  // ---- 表示データ（DISPLAY）をどこまで取りに行くか -------------------------
  //
  // 索引が数える係を持っているので、取得に残った仕事は**絵を出すこと**だけ。
  // 絵は「いま画面に出している商品」のぶんしか要らない。母集合やタグの残りページは
  // 必要になるまで取りに行かない（issue #811: 絞り込み1回で 90リクエスト・2.89MB）。

  // 立ち上げが済んだか。母集合の取得に要る設定（PAGE_SIZE / TOTAL）は
  // ファイルのずっと下で代入されるので、それより前に取りに行くと
  // `limit=undefined` の URL を叩く。
  var BOOTED = false;

  // 全商品ぶんの表示項目が要る操作か。
  //
  // ・商品名検索: 索引はタイトルを持たない（searchText は空のまま）
  // ・並び替え: 「おすすめ」（manual）以外は、**先頭48枚が母集合のどこから来るか
  //   分からない**。価格は索引が持っているので並べ替え自体はできるが、カードの絵は
  //   DISPLAY にしか無い。実測（本番 /collections/sash-window・価格の安い順）:
  //   母集合の1ページ目だけだと48枚中46枚が骨のカードになる。
  //
  // 「おすすめ」のままなら索引の順＝コレクションの並び順なので、1ページ目で足りる。
  function needsFullDisplay(){ return !!TEXT_Q || (SORT && SORT !== SORT_DEFAULT); }

  // いま出す n 件ぶんの絵が手元にあるか。無ければ骨のカード（.sg-card--pending）が並ぶ。
  // ⚠️ **索引が無い経路では常に false。** 索引が無ければ数えるのも母集合なので、
  // 従来どおり最後まで追わせる。
  function displayCoversShown(n){
    if (!INDEX_ROWS || !data || !data.products) return false;
    var list = sortList(filtered());
    var want = Math.min(list.length, n || shown || RENDER_CHUNK);
    for (var i = 0; i < want; i++){
      if (!DISPLAY[list[i].handle]) return false;
    }
    return true;
  }

  // ---- 既定の並び（おすすめ）は「いまのコレクションの並び」に従う ------------
  // コレクションの並び替えは全件 BEST_SELLING（2026-09-24 実測）で、売れるたびに並びが動く。
  // 索引の h は焼いた時点の並びなので、焼いた翌日には先頭48件が1件も一致しなくなっていた
  // （/collections/sash-window-mado・9/23 焼き・先頭48件の一致 0/48）。その並びで描くと、
  // 1ページ目に無い商品が先頭に来て骨のまま待たされ、Liquid の初期表示から並びも入れ替わる。
  // 母集合のページは届いた順＝いまの並びなので、届いた順番を覚えてそれで並べる。
  // 数えるのは引き続き索引（並べ替えるだけで件数は動かない）。まだ届いていない商品は
  // 届いた商品の後ろに、索引の並びのまま置く。
  var LIVE_POS = {}, LIVE_NEXT = 0;
  function learnLiveOrder(products){
    (products || []).forEach(function(p){
      if (p && p.handle && !(p.handle in LIVE_POS)) LIVE_POS[p.handle] = LIVE_NEXT++;
    });
  }
  function byLiveOrder(list){
    return list.map(function(row, i){ return { row: row, i: i }; }).sort(function(a, b){
      var x = LIVE_POS[a.row.handle], y = LIVE_POS[b.row.handle];
      if (x == null && y == null) return a.i - b.i;
      if (x == null) return 1;
      if (y == null) return -1;
      return x - y;
    }).map(function(e){ return e.row; });
  }

  function sortList(list){
    var cmp = SORTERS[SORT];
    if (!cmp && SORT === SORT_DEFAULT && INDEX_ROWS && LIVE_NEXT) return byLiveOrder(list);
    return cmp ? list.slice().sort(cmp) : list;
  }

  // 標準UIへ戻す。軸が立たない・商品が取れない・例外、のときだけ通る道。
  // 隠していたのは Liquid が出した `<style data-sg-hide-native>` なので、それを消せば戻る。
  // インラインで `display:none` を当てていた頃と違い、戻すときに元の display 値を
  // 知らなくてよい。
  var bailed = false;
  function bail(){
    if (bailed) return;
    bailed = true;
    var hide = document.getElementById('SGHideNative-' + sectionId);
    if (hide) hide.remove();
    // ガイド側は畳む。スケルトンだけが残ると「壊れている」ように見える。
    if (resultsWrap) resultsWrap.hidden = true;
    if (disclosure) disclosure.hidden = true;
  }

  function renderResults(){
    updateTextSearchStatus();
    // 確定しているかは選択・商品名検索・表示データの揃い具合で変わる。毎回追随させる。
    setExact();
    // 焼き込みで軸だけ先に描いている段階（商品はまだ1件も来ていない）。
    // グリッドをここで描くと「該当なし」が一瞬出るので、スケルトンのまま置く。
    // 件数だけは焼き込みが知っているので先に出す（サーバの総数と同じ値）。
    if (!data.products.length && !POOL_FULL){
      countEl.innerHTML = digestUsable(null) ? '<b>' + digestShownTotal() + '</b> 件' : '';
      return;
    }
    // ⚠️ **いまの並びが1件も届いていないあいだは、Liquid の初期カードを描き直さない。**
    // 索引は CDN から母集合の1ページ目より先に着く。ここで索引の並び（焼いた時点の並び）で
    // 描くと、正しい並び・正しい価格で出ていた初期カードが一度骨に置き換わり、1ページ目が
    // 届いた瞬間にまた元の並びへ戻る（0.2秒→0.7秒の入れ替わり）。選択・検索・並び替えが
    // 無い既定の表示でだけ待つ。件数は下の countEl 以降で通常どおり出す。
    var holdLiquid = INDEX_ROWS && !LIVE_NEXT && SORT === SORT_DEFAULT && !TEXT_Q
      && !selList().length && gridEl && gridEl.querySelector(':scope > .sg-card');
    var list = sortList(filtered());
    if (!shown) shown = RENDER_CHUNK;
    var page = list.slice(0, shown);
    // お気に入りボタンはリンクの入れ子にできないので、カードをラッパーで包んで
    // ボタンを <a class="sg-card"> の兄弟として置ける形にする（ボタンの差し込みは wishlist-collection-buttons）。
    if (!holdLiquid) gridEl.innerHTML = page.map(function(row){
      // ⚠️ **数える係と絵を出す係を分けている。** row は索引から来ていて
      // タイトルも画像も持たない。表示に使う項目は別経路（母集合の1ページ目や
      // タグ取得）で届いたものを handle で引き当てる。
      // まだ届いていない商品は骨だけ描き、届いたら描き直す。
      var p = DISPLAY[row.handle] || row;
      // ⚠️ **タイトルが無いときに素で連結してはいけない。** 索引行は title を
      // 持たないので、そのまま足すと文字列 "undefined" がカードに並ぶ。
      // 骨として描いて、届いたら描き直す（この関数がもう一度通る）。
      var pending = !p.title;
      return '<div class="sg-card-wrap" role="listitem">'
        + '<a class="sg-card' + (pending ? ' sg-card--pending' : '') + '" href="/products/' + p.handle + '">'
        + sgMediaHtml(p)
        + '<div class="sg-card__body">'
        + (p.vendor ? '<div class="sg-card__vendor">' + p.vendor + '</div>' : '')
        + '<div class="sg-card__title">' + (p.title || '') + '</div>'
        + priceRowsHtml(p, pending) + '</div></a>'
        // お気に入りボタンの受け皿。カード本体（<a>）の外・下に置くので、
        // ボタンは画像に重ならずカードの右下に出る。`:empty` で畳むため空白を入れない。
        + '<div class="sg-card__wishlist" data-wishlist-home></div>'
        + '</div>';
    }).join('');
    window.themeWishlistMount('.sg-card-wrap');
    sgObserveCards();
    // 未取得商品のタイトルは検索できないため、途中の0件を「該当なし」にしない。
    emptyEl.hidden = list.length > 0 || (!!TEXT_Q && !countsAreSettled());
    // 母集合が揃うまでは件数を出さない。手元にある分で数えると「250件」が一瞬見えて
    // 直後に本当の件数へ飛ぶし、サーバの総数で埋めても絞り込み後の数とは意味が違う
    // （検索では母集合を集めきれないことがあり、そこで数字が入れ替わっていた。Refs #547）。
    // 確定するまで空にしておけば、嘘の数字を一度も見せずに済む。
    // 件数を出してよい条件。
    //   1. 母集合が揃っている（PARTIAL が false）
    //   2. サーバから全ページ引き終えた（上位集合を絞った結果＝最終結果）
    //   3. 選択が空で、焼き込みが全体の件数を知っている
    //   4. **1軸1値だけの選択なら、焼き込みがその件数をそのまま持っている**
    //      （母数が母集合全体なので、焼き込みの集計と一致する）
    var shownCount = countsAreSettled()
      ? list.length
      : (digestUsable(null) ? digestShownTotal() : singleSelectionCount());
    countEl.innerHTML = shownCount == null ? '' : '<b>' + shownCount + '</b> 件';

    // 件数は常に全件を出す（絞り込みの手応えは総数で決まる）。描画だけを刻む。
    // 「さらに表示」の残り件数も確定してから出す。サーバの総数から引くと
    // 件数と同じで実際より多い数字になる（一覧に出せるのは母集合のぶんだけ）。
    //
    // ⚠️ サーバ経由で確定しているときも出す。PARTIAL だけで見ると、件数は
    // 「320 件」と出るのにグリッドは48枚で止まり、49件目以降へ行く手段が無くなる。
    var rest = countsAreSettled() ? list.length - page.length : 0;
    moreEl.hidden = rest <= 0;
    // テキストは毎回書き換える。0件のときに前回の「残り N 件」が残っていると、
    // 一瞬でも表示された時に嘘の件数が出る
    moreBtn.textContent = rest > 0 ? 'さらに表示（残り ' + rest + ' 件）' : '';

    // 選択チップ（各値）＋「すべて解除」
    //
    // 「すべて解除」はもともと上部ウィザードのパンくず（breadcrumbEl）にしか無かった。
    // ところがパンくずは `<details data-sg-disclosure>` の中にあり、その details は
    // サイドのみのページ（flat = 第1・第2階層）では `hidden` になる。
    // つまりボタンは DOM に生成されるのに一度も表示されず（実測 offsetParent === null）、
    // 「押しても何も起きない／見つからない」状態になっていた。モバイルの全画面パネルにも
    // 解除手段が無かった。選択チップと同じ場所（結果バー）に置けば、どのモードでも出る。
    var chips = [];
    activeAxes().forEach(function(ax){ sel(ax.key).forEach(function(v){ chips.push({ ax: ax.key, v: v }); }); });
    chipsEl.innerHTML = chips.map(function(c){
      return '<span class="sg-chip" data-ax="' + c.ax + '" data-val="' + c.v + '">' + dispHtml(c.ax, c.v) + ' ✕</span>';
    }).join('') + (chips.length
      ? '<button type="button" class="sg-chip sg-chip--reset" data-sg-reset>↺ すべて解除</button>'
      : '');
  }

  // すべての選択を捨てて先頭に戻す。パンくず・チップ横・パネル内のボタンで共有する。
  function resetAll(){
    selections = {};
    stepCursor = 0;
    invalidate();
    // 絵が足りていれば取りに行かない。数えるのは索引なので件数は変わらない
    if ((!POOL_FULL || !DISPLAY_FULL) && !displayCoversShown(RENDER_CHUNK)) { ensureServerRows(); return; }
    render();
  }

  function optCount(axKey, v){ return countsFor(axKey)[v] || 0; }

  // 残N件が確定しているか。確定していないあいだは 0 を理由に選択肢を無効化しない。
  //
  // ⚠️ **anchor に使った軸だけは確定にしてはいけない。** その軸の残N件は
  // 「その軸の選択を外した母集合」を母数に数えるが、手元にあるのは anchor タグで
  // 絞った集合なので、**その軸の他の値は必ず 0 になる**。
  // 実際には商品があるのに 0 と出て、CSS が押せなくする。
  var ANCHOR_AX = null;
  function countsAreExact(axKey){
    // ⚠️ **商品名検索は索引で答えられない。** タイトルは DISPLAY にしか無く、
    // 母集合は40ページ（10,000件）で打ち止め。揃っていないのに「確定」にすると、
    // 実際に商品がある選択肢が 0 と数えられ data-sg-zero=true で**押せなくなる**。
    // 商品名の索引が貼れていれば（TEXT_READY）、索引だけで答えられる。
    if (INDEX_ROWS && TEXT_Q && !DISPLAY_FULL && !TEXT_READY) return false;
    if (!PARTIAL) return true;                       // 母集合が揃っている
    if (DIGEST_COUNTS && !selList().length) return true;  // 選択が空＝焼き込みが正しい
    if (!SERVER_DONE) return false;
    return axKey !== ANCHOR_AX;                      // anchor 軸だけは確定にしない
  }

  // 1軸1値だけを選んでいるとき、その件数は焼き込みがそのまま持っている。
  // 母数が母集合全体なので、サーバから全ページ取らなくても確定する。
  // 実測: exterior で `maker:lixil` を押すと、全ページ取得は9.2秒かかるが
  // 焼き込みは同じ 5,734 件を即座に返す。
  function singleSelectionCount(){
    if (!DIGEST_COUNTS || TEXT_Q) return null;
    var list = selList();
    if (list.length !== 1 || list[0].vals.length !== 1) return null;
    var m = DIGEST_COUNTS[list[0].k];
    var n = m && m[list[0].vals[0]];
    return typeof n === 'number' ? n : null;
  }

  // スマホでは軸ごとに開閉する。再描画やパネルの開き直しでも開閉状態を維持する。
  var expandedSideAxes = Object.create(null);

  // サイドメニュー（PCは全軸を展開・残N件・選択状態はウィザードと共有）
  // 寸法も一覧（クリック）で出す。選択肢が増えすぎる軸は build() の
  // autoBucketWidths() が刻みを自動で決めてグループにしてあるので、
  // ここでは他の軸と同じ扱いで並べるだけでよい。
  function renderSide(){
    var focused = document.activeElement;
    var focusedOpt = sideEl.contains(focused) && focused.closest('.sg-side__opt');
    var focusedToggle = sideEl.contains(focused) && focused.closest('[data-sg-axis-toggle]');
    var focusedReset = sideEl.contains(focused) && focused.closest('[data-sg-reset]');
    var scrollTop = sideEl.scrollTop;
    // ヘッダの×とフッタの「N件を見る」はモバイルの全画面パネル用。PCでは CSS で隠す
    sideEl.innerHTML = '<div class="sg-side__scroll">'
      + '<div class="sg-side__head">絞り込み'
      + '<button type="button" class="sg-side__close" data-sg-filter-close aria-label="絞り込みを閉じる">'
      + '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>'
      + '</button></div>'
      + activeAxes().map(function(ax){
      var body;
      {
        body = axValues(ax).map(function(v){
          var c = optCount(ax.key, v);
          var on = sel(ax.key).indexOf(v) >= 0;
          // サイドはテキストだけ。選択肢の画像は上部のウィザードUIにだけ出す
          // ⚠️ 残N件が確定していないあいだは 0 を理由に無効化しない。
          // 1ページ目（最大250件）を母数に数えた 0 は嘘で、CSS が
          // `pointer-events: none` を当てるので**実際には商品がある選択肢が押せなくなる**。
          return '<label class="sg-side__opt" data-sg-ax="' + ax.key + '" data-sg-value="' + v + '" data-sg-zero="'
            + ((c === 0 && !on && countsAreExact(ax.key)) ? 'true' : 'false') + '">'
            + '<input type="checkbox"' + (on ? ' checked' : '') + '>'
            + '<span>' + dispHtml(ax.key, v) + '</span><span class="sg-side__opt-c">' + c + '</span></label>';
        }).join('');
      }
      var expanded = expandedSideAxes[ax.key] === true;
      var count = sel(ax.key).length;
      var optionsId = 'SGAxis-' + sectionId + '-' + encodeURIComponent(ax.key);
      return '<div class="sg-side__axis"><div class="sg-side__axis-label">' + ax.label + '</div>'
        + '<button type="button" class="sg-side__axis-toggle" data-sg-axis-toggle="' + ax.key + '"'
        + ' aria-expanded="' + expanded + '" aria-controls="' + optionsId + '">'
        + '<span>' + ax.label + '</span>'
        + (count ? '<span class="sg-side__axis-selected">' + count + '件選択</span>' : '')
        + '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button><div class="sg-side__axis-options" id="' + optionsId + '">' + body + '</div></div>';
    }).join('') + '</div>'
      + '<div class="sg-side__apply">'
      + '<button type="button" class="sg-side__reset" data-sg-reset="footer" aria-label="絞り込みをすべてクリア">クリア</button>'
      + '<button type="button" class="sg-apply-btn" data-sg-filter-close>'
      + '<b>' + filtered().length + '</b> 件を見る</button></div>';
    // 選択・クリア時の再描画で、キーボードのフォーカスと読んでいた位置を失わない。
    var focusTarget;
    if (focusedOpt) {
      var opts = sideEl.querySelectorAll('.sg-side__opt');
      for (var i = 0; i < opts.length; i++) {
        if (opts[i].getAttribute('data-sg-ax') === focusedOpt.getAttribute('data-sg-ax')
          && opts[i].getAttribute('data-sg-value') === focusedOpt.getAttribute('data-sg-value')) {
          focusTarget = opts[i].querySelector('input');
          break;
        }
      }
    } else if (focusedReset) {
      focusTarget = sideEl.querySelector('[data-sg-reset="' + focusedReset.getAttribute('data-sg-reset') + '"]');
    } else if (focusedToggle) {
      var toggles = sideEl.querySelectorAll('[data-sg-axis-toggle]');
      for (var j = 0; j < toggles.length; j++) {
        if (toggles[j].getAttribute('data-sg-axis-toggle') === focusedToggle.getAttribute('data-sg-axis-toggle')) {
          focusTarget = toggles[j];
          break;
        }
      }
    }
    if (focusTarget) focusTarget.focus({ preventScroll: true });
    sideEl.scrollTop = scrollTop;
    syncFilterActions();
  }

  function render(){
    shown = 0;                 // 条件が変わったら先頭ページに戻す（さらに表示は renderResults だけ通る）
    // 選択が変わる経路はすべて render() を通る。件数キャッシュはここで捨てる。
    // 並び替え・「さらに表示」は renderResults() だけを呼ぶので、絞り込み結果を
    // 数え直さずに済む（条件が変わっていないのだから正しい）。
    invalidate();
    var picked = selectedCount();
    stepsEl.innerHTML = activeAxes().map(function(ax, idx){
      // step: 開示は stepCursor のみで決まる（左サイドの選択では進まない）。flat: 全表示
      var hidden = !flat && idx > stepCursor;
      var locked = !flat && sel(ax.key).length > 0 && idx < stepCursor;
      var counts = countsFor(ax.key);      // 軸ごとに1パス（選択肢ごとに数え直さない）
      var opts = axValues(ax).map(function(v){
        var c = counts[v] || 0;
        var on = sel(ax.key).indexOf(v) >= 0;
        var vm = vmeta(ax.key, v);
        return '<button type="button" class="selection-guide__option" data-sg-ax="' + ax.key + '" data-sg-value="' + v + '"'
          + ' data-sg-selected="' + (on ? 'true' : 'false') + '" data-sg-zero="'
          + ((c === 0 && !on && countsAreExact(ax.key)) ? 'true' : 'false') + '">'
          + (vm && vm.i ? '<span class="selection-guide__option-thumb"><img src="' + vm.i + '" alt="" loading="lazy"></span>' : '')
          + '<span class="selection-guide__option-label">' + dispHtml(ax.key, v) + '</span>'
          + (vm && vm.d ? '<span class="selection-guide__option-sub">' + vm.d + '</span>' : '')
          + '<span class="selection-guide__option-count">' + c + ' 件</span></button>';
      }).join('');
      var num = flat ? '' : '<span class="selection-guide__step-num">' + (idx + 1) + '</span>';
      return '<div class="selection-guide__step" data-sg-step data-sg-locked="' + (locked ? 'true' : 'false') + '"' + (hidden ? ' hidden' : '') + '>'
        + '<div class="selection-guide__step-heading">' + num
        + '<span class="selection-guide__step-label">' + ax.label + '</span></div>'
        + '<div class="selection-guide__options">' + opts + '</div></div>';
    }).join('');

    breadcrumbEl.innerHTML = '';
    axes.forEach(function(ax){
      sel(ax.key).forEach(function(v){
        var chip = document.createElement('span');
        chip.className = 'selection-guide__chip';
        chip.textContent = ax.label + ': ' + dispVal(ax.key, v);
        breadcrumbEl.appendChild(chip);
      });
    });
    if (picked > 0){
      var reset = document.createElement('button');
      reset.type = 'button';
      reset.className = 'selection-guide__chip selection-guide__chip--reset';
      reset.textContent = '↺ すべて解除';
      reset.onclick = resetAll;
      breadcrumbEl.appendChild(reset);
    }
    renderSide();
    renderResults();
    renderFilterBadge();
    writeQuery();   // 選択の変更経路すべて（ウィザード／サイド／チップ解除／全解除）を通る
  }

  // 選択の適用（ウィザード・サイドメニュー共通）
  // fromWizard=true のときだけ stepCursor を動かす
  function applyPick(ax, val, fromWizard){
    // **常に受ける。** 母集合が揃っていなくても、押した結果は
    // ensureServerRows() が「サーバ取得 → 母集合 → 待ち」の順で解決する。
    USER_PICKED = true;
    selections[ax] = sel(ax);
    // 軸内 複数選択トグル（flat・step 共通。同じ軸の値どうしは OR）
    var i = selections[ax].indexOf(val);
    if (i >= 0) selections[ax].splice(i, 1); else selections[ax].push(val);
    if (fromWizard && !flat){
      var idx = axIndex(ax);
      if (idx >= 0){
        // 1つでも選ばれていれば次ステップを開示（1つ外しても開いたまま）/ 全部外したらそのステップ以降を畳む
        stepCursor = sel(ax).length ? Math.max(stepCursor, idx + 1) : idx;
      }
    }
    // ⚠️ **選択を書き換えたら必ずキャッシュを捨てる。**
    // selList() は前回 render 時点のスナップショットを返すので、捨てないと
    // anchorTag() も singleSelectionCount() も **1クリック前の選択**を見る。
    // 焼き込み描画直後の最初のクリックでは selCache が空なので anchor が決まらず、
    // 商品も0件なので早期 return して**押しても何も起きない**（この変更が狙った操作そのもの）。
    invalidate();
    // ⚠️ **数が足りていても絵が足りなければ通す。** 索引は POOL_FULL を立てるが、
    // タイトルも画像も持っていない。ここで返してしまうと、母集合が全ページ
    // 揃うまで（8〜18秒）カードが骨のまま並ぶ。
    // 絵が足りていれば取りに行かない。数えるのは索引なので件数は変わらない
    if ((!POOL_FULL || !DISPLAY_FULL) && !displayCoversShown(RENDER_CHUNK)) { ensureServerRows(); return; }
    render();
  }

  // その選択がサーバで引ける形か（実タグの軸が1つでも選ばれるか）
  function canServerFilter(ax, val){
    if (isRealTag(ax, val)) return true;
    var list = selList();
    for (var i = 0; i < list.length; i++){
      for (var j = 0; j < list[i].vals.length; j++){
        if (isRealTag(list[i].k, list[i].vals[j])) return true;
      }
    }
    return false;
  }

  // 選択に合う上位集合をサーバから取り、それを母集合の代わりに使う。
  // 取れたら描く。取れなければ母集合の到着を待つ（従来どおり）。
  // サーバ経由で据えた上位集合を捨てて、母集合の経路へ戻す。
  //
  // ⚠️ **選択を変える経路すべてから呼ぶ。** ensureServerRows() の中だけに置くと、
  // resetAll() とチップの✕が通らず、選択ゼロなのにグリッドは前の絞り込みのまま、
  // 件数もその確定値のまま、という画面が母集合が揃うまで残る。
  function clearServerRows(){
    // ⚠️ **世代を進める。** 進めないと、まだ飛んでいるタグ取得が後から着弾して
    // 母集合をタグ1ページ目（250件）で置き換え、ANCHOR_AX=null のまま
    // SERVER_DONE=true にする。countsAreExact() が全軸を「確定」にするので、
    // **実在する選択肢が0件と判定されて押せなくなる**。
    serverGen++;
    SERVER_DONE = false;
    ANCHOR_AX = null;
    if (SERVER_ROWS){
      SERVER_ROWS = null;
      data.products = POOL_ROWS || [];
    }
    setExact();
  }

  function ensureServerRows(){
    clearServerRows();
    // ⚠️ **早期 return より前で前回の結果を捨てる。** ここを後ろに置くと、
    // 絞り込みを解除したのに SERVER_DONE が true のまま残り、
    // 「選択ゼロなのに件数も商品も絞られたまま」になる（母集合が揃うまで続く）。

    var a = anchorTag();
    if (!a){
      // 実タグの軸が選ばれていない（寸法バケット・価格帯・指定なしだけ）。
      // 母集合を待つしかない。
      //
      // ⚠️ **商品が1件も無い状態で render() を通してはいけない。**
      // activeAxes() が未選択の全軸で母数0を見て `if (!base) return false` で落とし、
      // 軸が選択中の1本に崩れる。焼き込み描画の直後（data.products が空）は必ずこれになる。
      // 商品が0件でも、**選択が空なら描いてよい**。焼き込みが全軸の件数を
      // 持っているので baseSize() が 0 にならず、軸は崩れない。
      // ⚠️ ただし描かないまま返すと、解除したのにグリッドが前の結果のまま残る。
      // 選択が空で商品も無いときは、グリッドを空にしてから待つ。
      setLoadingResults(!data.products.length && !POOL_ROWS);
      if (!data.products.length && !POOL_FULL && selList().length) return;
      if (!data.products.length && !selList().length && gridEl) gridEl.innerHTML = '';
      render();
      return;
    }
    // 索引があれば選択後の件数は既に確定している。表示用の商品を取りに行く前に
    // パネル・バッジ・URLも更新する。到着後の repaintIndex() は一覧だけを描くため、
    // ここで同期しないとパネルの選択数と「N件を見る」が前の条件のまま残る。
    if (INDEX_ROWS) render();
    var gen = ++serverGen;
    setLoadingResults(true);
    function use(list, done){
      if (done && !settled) { settled = true; endFetch(); }
      if (gen !== serverGen) return;          // 追い越された
      // 欠けたページがあるなら「確定」にしない（少ない件数を正しい数として出さない）
      if (list && list.incomplete) { list = list.list; done = false; }
      // ⚠️ **索引経路では POOL_FULL で抜けてはいけない。** 索引が POOL_FULL を
      // 立てるので、ここで返すとタグ取得の結果（タイトル・画像）が毎回捨てられ、
      // カードが母集合待ちのあいだ骨のまま並ぶ。
      if (POOL_FULL && !INDEX_ROWS) { render(); return; }    // 母集合が揃った
      if (!list){
        if (!settled) { settled = true; endFetch(); }
        // 引けなかった（429がリトライ後も解けない / 404 / そのタグが0件）。
        // ⚠️ **商品が0件のまま render() を通さない。** activeAxes() が全軸を落として
        // 軸が1本に崩れる。母集合の到着を待つ。
        setLoadingResults(!data.products.length && !POOL_ROWS);
        if (!data.products.length && !POOL_FULL && selList().length) return;
        render();
        return;
      }
      // サーバの結果を母集合として据える。**上位集合なので、あとは今まで通り絞れば合う。**
      var sb = build(list).products;
      rememberDisplay(sb);
      // 数えるのは索引。ここは表示用に覚えるだけ
      if (INDEX_ROWS){ setExact(); repaintIndex(); return; }
      SERVER_ROWS = sb;
      SERVER_DONE = done;
      setExact();
      data.products = SERVER_ROWS;
      invalidate();
      render();
    }
    ANCHOR_AX = a.key;
    beginFetch();
    var settled = false;
    fetchByTag(a.key, a.val,
               function(list){ use(list, false); },
               function(list){ use(list, true); },
               // 追う量を**画面に出す絵のぶんだけ**にする。届いたページを覚えてから
               // 測る（覚える前に測ると永久に足りない）。索引が数えているので、
               // ここで止めても件数・残N件・「さらに表示」の残りは変わらない。
               function(chunk){
                 if (gen !== serverGen) return true;       // 追い越された＝もう要らない
                 if (needsFullDisplay()) return true;      // 全件は ensureDisplayPool() が取る
                 rememberDisplay(build(chunk).products);
                 return displayCoversShown();
               });
  }

  // 「さらに表示」で足りなくなった絵を追う。**数字には関与しない**（数えるのは索引）。
  //
  // ⚠️ **ensureServerRows() は通さない。** あれは選択が変わった前提で render() を呼び、
  // render() は shown を 0 に戻す。押した「さらに表示」がその場で畳まれる。
  function chaseMoreDisplay(){
    if (!INDEX_ROWS || DISPLAY_FULL) return;
    var a = anchorTag();
    // 実タグの軸が選ばれていない（寸法バケット・価格帯・指定なしだけ）＝
    // タグでは引けないので、母集合を1ページずつ足す
    if (!a) { chasePoolPage(); return; }
    var gen = serverGen;
    var settled = false;
    beginFetch();
    function done(list){
      // ⚠️ **endFetch だけを1回に絞る。** ここで return してしまうと、止めていた
      // 続きが届いたときに描き直せない（キャッシュ済みのタグは先に古いぶんで呼ばれる）。
      if (!settled) { settled = true; endFetch(); }
      if (gen !== serverGen) return;
      if (list && list.incomplete) list = list.list;
      if (!list || !list.length) return;
      rememberDisplay(build(list).products);
      renderResults();
    }
    fetchByTag(a.key, a.val, function(){}, done, function(chunk){
      if (gen !== serverGen) return true;
      rememberDisplay(build(chunk).products);
      return displayCoversShown();
    });
  }

  // 結果側だけを「読み込み中」にする（軸は押せるまま）。
  //
  // ⚠️ **POOL_FULL では判定しない。** 429 のリトライ失敗や MAX_PAGES 打ち切りで
  // FETCH_INCOMPLETE が立つと POOL_FULL は恒久的に false のままなので、
  // `setLoadingResults(!POOL_FULL)` だと二度と解除されず、CSS の
  // `pointer-events: none` で**商品カードのリンクが永久に死ぬ**。
  // 「いま実際に取りに行っているか」だけで決める。
  var pendingFetches = 0;
  // 件数が確定しているか。
  //
  // 索引は全商品ぶんなので、**軸の選択だけで絞っているあいだは常に確定している**
  // （母集合の到着状況やタグ取得の進み具合に関係ない）。ここを「母集合が
  // 揃ったか」だけで見ると、索引経路で「さらに表示（残り N 件）」が出るのに
  // 押せない状態が残る。
  //
  // ⚠️ **商品名検索だけは索引で答えられない。** 索引はハンドルと価格と軸の値しか
  // 持たず、タイトルは母集合・タグ取得で届いたぶん（DISPLAY）しかない。
  // 母集合は40ページ（10,000件）で打ち止めなので、それを超えるコレクションでは
  // 一部の商品のタイトルを永久に知らない。知らないまま数えると
  // **実際より少ない数を「確定値」として出す**ので、確定にしない。
  // 商品名の索引（facet-text）が貼れていれば全件のタイトルを持っているので確定する。
  function countsAreSettled(){
    if (INDEX_ROWS) return !(TEXT_Q && !DISPLAY_FULL && !TEXT_READY);
    return !PARTIAL || SERVER_DONE;
  }
  // いま出している件数が最終値か。**薄くしない／空欄にしない判断に使う。**
  //
  // 焼き込みは絞り込み対象の総数を持っているので、選択が空ならその数字は確定していて、
  // 母集合や索引の到着を待つ理由が無い。ここを countsAreSettled() だけで見ると、
  // **正しい件数を出しているのに最大10秒 opacity 0.55 のまま薄い**
  // （実測: sash-window で 0.77秒に 19,586件 が出て、濃くなるのは 9.98秒）。
  //
  // 「さらに表示」の残り件数は countsAreSettled() のままにする。母集合が
  // 揃っていないあいだ rest は 0 で、ボタンは hidden なので押せる状態にならない。
  function countShownIsFinal(){ return countsAreSettled() || digestUsable(null); }
  function setExact(){
    if (resultsWrap) resultsWrap.setAttribute('data-sg-results-exact', countShownIsFinal() ? 'true' : 'false');
  }

  function setLoadingResults(on){
    if (!resultsWrap) return;
    resultsWrap.setAttribute('data-sg-results-loading', on ? 'true' : 'false');
  }
  function beginFetch(){ pendingFetches++; setLoadingResults(true); }
  function endFetch(){
    pendingFetches = Math.max(0, pendingFetches - 1);
    if (!pendingFetches) setLoadingResults(false);
  }

  // ---- モバイル: 絞り込みを全画面パネルで開く ----------------------------
  // サイドバーは場所を取るので、モバイルではボタン1つに畳んでタップで全画面に出す。
  // DOM は動かさない（同じ [data-sg-side] を position: fixed で出すだけ）ので、
  // 選択のイベント委譲・再描画はPCと同じ経路をそのまま通る。
  function renderFilterBadge(){
    if (!filterBadge) return;
    var n = selectedCount();
    filterBadge.hidden = n === 0;
    filterBadge.textContent = n;
  }

  function filtersOpen(){ return layoutEl && layoutEl.getAttribute('data-sg-filters-open') === 'true'; }

  var filterActionsObserver = null;
  function syncFilterActions(){
    if (filterActionsObserver) filterActionsObserver.disconnect();
    var style = document.documentElement.style;
    if (!filtersOpen()) {
      style.removeProperty('--sg-filter-actions-height');
      return;
    }
    var actions = sideEl.querySelector('.sg-side__apply');
    if (!actions) return;
    function measure(){
      // セーフエリア・文字の折り返し・画面回転を含め、固定バーの実高に追随する。
      style.setProperty('--sg-filter-actions-height', actions.getBoundingClientRect().height + 'px');
    }
    measure();
    if (typeof ResizeObserver !== 'undefined') {
      filterActionsObserver = new ResizeObserver(measure);
      filterActionsObserver.observe(actions);
    }
  }

  function setFilters(open){
    if (!layoutEl) return;
    layoutEl.setAttribute('data-sg-filters-open', open ? 'true' : 'false');
    if (filterOpenBtn) filterOpenBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    // 背面のページが動かないように固定する。閉じたら元のスクロール位置に戻す
    if (open) {
      lockedScrollY = window.scrollY;
      document.documentElement.classList.add('sg-filters-locked');
      document.body.style.top = (-lockedScrollY) + 'px';
      sideEl.scrollTop = 0;
      var closeBtn = sideEl.querySelector('[data-sg-filter-close]');
      if (closeBtn) closeBtn.focus();
    } else {
      document.documentElement.classList.remove('sg-filters-locked');
      document.body.style.top = '';
      // 開いている間に絞り込みが変わると本文の高さも変わる。1フレーム待って
      // レイアウトが確定してから元の位置に戻す
      var y = lockedScrollY;
      window.scrollTo(0, y);
      requestAnimationFrame(function(){ window.scrollTo(0, y); });
      if (filterOpenBtn) filterOpenBtn.focus();
    }
    syncFilterActions();
  }

  var lockedScrollY = 0;

  // 入力は商品情報の通信から独立させる。後から届いた情報も repaintIndex で検索し直す。
  function updateTextSearchStatus(){
    if (!qStatusEl) return;
    var incomplete = !!TEXT_Q && (!data || !countsAreSettled());
    qStatusEl.hidden = !incomplete;
    qStatusEl.textContent = incomplete
      ? (resultsWrap.classList.contains('sg-loading')
        ? '商品情報を読み込みながら検索しています。'
        : '一部の商品情報を取得できていないため、読み込めた範囲の検索結果を表示しています。')
      : '';
  }
  var qTimer = null;
  var qComposing = false;
  function applyTextQuery(){
    // 正規化してから比べる。生の入力で比べると「ﾗｼｯｻ」と「ラシッサ」のように
    // 結果が同じになる打鍵でも毎回再描画が走る。
    if (normText(qEl.value || '') === TEXT_Q) return;
    setTextQuery(qEl.value || '');
    if (qClearEl) qClearEl.hidden = !TEXT_Q;
    syncQueryParam();
    if (data) render(); else updateTextSearchStatus();
  }
  function syncQueryParam(){
    // 素の一覧側と同じ `filter.q` を使う。リンクを共有しても同じ状態で開く。
    try {
      var u = new URL(window.location.href);
      if (TEXT_Q) u.searchParams.set(Q_PARAM, qEl.value.trim());
      else u.searchParams.delete(Q_PARAM);
      window.history.replaceState({}, '', u.toString());
    } catch (e) { /* URL が扱えない環境では諦める */ }
  }
  if (qEl){
    qEl.addEventListener('compositionstart', function(){
      USER_TYPED_QUERY = true;
      qComposing = true;
      clearTimeout(qTimer);
    });
    qEl.addEventListener('compositionend', function(){
      qComposing = false;
      clearTimeout(qTimer);
      applyTextQuery();
    });
    qEl.addEventListener('input', function(e){
      USER_TYPED_QUERY = true;
      clearTimeout(qTimer);
      if (qComposing || e.isComposing) return;
      qTimer = setTimeout(applyTextQuery, 180);
    });
    qEl.addEventListener('keydown', function(e){
      if (e.key !== 'Enter' || qComposing || e.isComposing || e.keyCode === 229) return;
      e.preventDefault();
      clearTimeout(qTimer);
      applyTextQuery();
    });
  }
  if (qClearEl){
    qClearEl.addEventListener('click', function(){
      USER_TYPED_QUERY = true;
      qComposing = false;
      qEl.value = '';
      clearTimeout(qTimer);
      applyTextQuery();
      qEl.focus();
    });
  }

  if (filterOpenBtn) filterOpenBtn.addEventListener('click', function(){ setFilters(true); });

  sideEl.addEventListener('click', function(e){
    if (e.target.closest('[data-sg-filter-close]')) { setFilters(false); return; }
    if (e.target.closest('[data-sg-reset]')) { resetAll(); return; }
    var toggle = e.target.closest('[data-sg-axis-toggle]');
    if (!toggle) return;
    var key = toggle.getAttribute('data-sg-axis-toggle');
    expandedSideAxes[key] = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', expandedSideAxes[key] ? 'true' : 'false');
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && filtersOpen()) setFilters(false);
  });

  // PC幅に戻ったときに開いたままだと fixed のパネルが残るので畳む
  window.addEventListener('resize', function(){
    if (filtersOpen() && window.innerWidth > 900) setFilters(false);
    else if (filtersOpen()) syncFilterActions();
  });

  // 並び順を入れ替える。**商品名順・新着順はここで初めて母集合を取りに行く。**
  // 索引はタイトルも公開日も持たないので、押されるまでは1本も飛ばさない。
  // 価格の安い順・高い順は索引が price を持っているので取得は要らない。
  function applySort(v){
    SORT = v || SORT_DEFAULT;
    // 取得の約束を返す。呼び出し側は、届いてから描き直すのに使う。
    return needsFullDisplay() ? ensureDisplayPool() : null;
  }
  if (sortEl){
    // リロード時にブラウザが select の値を復元する（Firefox など）ので、
    // 起動時に一度 DOM の値へ合わせる。合わせないと表示と実際の並びがずれる。
    applySort(sortEl.value);
    // 並べ替えの世代。二度続けて変えたとき、古い取得の返事で描き直さないための印。
    var sortGen = 0;
    sortEl.addEventListener('change', function(){
      var gen = ++sortGen;
      var pool = applySort(sortEl.value);
      // 並びが変わったら必ず先頭から描き直す。途中まで描いた状態のまま
      // 後ろだけ並べ替えると、ページ境界で順序が壊れる。
      shown = 0;
      // ⚠️ **並べ替えた先頭ぶんの絵が手元に無いうちに描かない。**
      // 索引はタイトルも画像も持たないので、ここで描くと骨のカード
      // （.sg-card--pending）がずらりと並ぶ。母集合を遅延取得にした
      // 拍子に、価格の安い順で48枚中46枚が約9秒ぶん空になっていた（#811）。
      // 届くまでは**前の一覧を出したまま**待ち、届いてから差し替える。
      if (!pool || displayCoversShown(RENDER_CHUNK)) {
        renderResults();      // 選択は変わっていないので軸UI・URLは触らない
        return;
      }
      setLoadingResults(true);
      // 取得が終われば描く。**揃わなくても描く。** 母集合を最後まで追っても
      // 絵が来ない商品はあるので（本番でも価格順で24枚は骨のまま残る）、
      // 揃うことを待ち条件にすると永久に描けない。
      pool.then(function(){
        if (gen !== sortGen) return;   // 追い越された
        setLoadingResults(false);
        renderResults();
      });
    });
  }

  moreBtn.addEventListener('click', function(){
    shown += RENDER_CHUNK;
    renderResults();          // 選択は変わっていないので軸UI・URLは触らない
    // 伸ばしたぶんの絵が手元に無ければ、止めておいた続きをここで追う
    if (!displayCoversShown()) chaseMoreDisplay();
  });

  stepsEl.addEventListener('click', function(e){
    var opt = e.target.closest('.selection-guide__option');
    if (!opt) return;
    applyPick(opt.getAttribute('data-sg-ax'), opt.getAttribute('data-sg-value'), true);
  });
  sideEl.addEventListener('change', function(e){
    var opt = e.target.closest('.sg-side__opt');
    if (!opt) return;
    applyPick(opt.getAttribute('data-sg-ax'), opt.getAttribute('data-sg-value'), false);
  });
  chipsEl.addEventListener('click', function(e){
    // 解除ボタンにも .sg-chip が付いているので、こちらを先に見る
    if (e.target.closest('[data-sg-reset]')) { resetAll(); return; }
    var chip = e.target.closest('.sg-chip');
    if (!chip) return;
    var ax = chip.getAttribute('data-ax'), val = chip.getAttribute('data-val');
    if (selections[ax]){
      var i = selections[ax].indexOf(val);
      if (i >= 0) selections[ax].splice(i, 1);
    }
    // ⚠️ ここも ensureServerRows() を通す。通さないとサーバ経由で据えた
    // 上位集合が残り、選択を外したのにグリッドと件数が前の絞り込みのままになる。
    invalidate();
    // 絵が足りていれば取りに行かない。数えるのは索引なので件数は変わらない
    if ((!POOL_FULL || !DISPLAY_FULL) && !displayCoversShown(RENDER_CHUNK)) { ensureServerRows(); return; }
    render();
  });

  // ---- Liquid から渡された設定 ------------------------------------------
  function parseMap(attr, sep){
    var out = {};
    (root.getAttribute(attr) || '').split(',').forEach(function(pair){
      var i = pair.indexOf(sep);
      if (i < 0) return;
      var k = pair.slice(0, i).trim(), v = pair.slice(i + 1).trim();
      if (k) out[k] = v;
    });
    return out;
  }
  function parseList(attr){
    return (root.getAttribute(attr) || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
  }
  // ---- 絞り込みの定義（コレクションのメタフィールド tuna.filter_items）--------
  // SPEC.md Part 2「定義モードの描画規則（JS）」。セクションが出す #SGDef-<section.id> に
  // 定義があれば、軸・見出し・選択肢・並び・形式を**定義どおりにだけ**出す（DEF）。
  // 判定の中身は assets/selection-guide-def.js（window.MJGuideDef）の純粋関数に任せる。
  // 定義が無い・空ならレガシー動作（DEF = null）。**DEF が無いときの挙動はどこも変えない。**
  // 読めない定義もレガシーで描き、理由を console と root の data-sg-def-error に1回だけ残す
  // （照合の表で「定義エラー」と分かるように）。
  var DEF_LIB = window.MJGuideDef || null;
  var DEF = null, DEF_ITEMS = null, DEF_KEEP = Object.create(null);
  (function(){
    var el = document.getElementById('SGDef-' + sectionId);
    if (!el) return;
    var text = el.textContent || '', reason = null;
    if (!DEF_LIB) {
      // ライブラリが読めていない。定義が書かれているのに使えないことだけ残す
      if (/\S/.test(text)) reason = 'no-lib';
    } else {
      var parsed = DEF_LIB.parse(text);
      if (parsed.ok) DEF = parsed.def;
      else if (parsed.error !== 'empty') reason = parsed.error;   // 空＝定義なし。警告しない
    }
    if (!reason) return;
    if (typeof console !== 'undefined' && console.warn) console.warn('[sg-def]', handle, reason);
    root.setAttribute('data-sg-def-error', reason);
  })();
  if (DEF) {
    DEF_ITEMS = DEF_LIB.keyIndex(DEF);
    // 定義どおりに描いていることを画面に残す（照合・目視で定義モードかどうかを見分ける）
    root.setAttribute('data-sg-def', 'active');
  }
  function defItem(key){
    return DEF_ITEMS && Object.prototype.hasOwnProperty.call(DEF_ITEMS, key) ? DEF_ITEMS[key] : null;
  }
  function defIsList(key){ var it = defItem(key); return !!it && it.show === 'list'; }
  // 定義がその組（軸, タグの生値）を通すか。定義外の key・list の未登録値は捨てる。
  // 商品行・索引行の値ごとに呼ばれるので、組ごとに1回だけ聞いて覚える。
  function defKeeps(key, val){
    var k = key + DEF_LIB.VALUE_SEP + val;
    if (!(k in DEF_KEEP)) DEF_KEEP[k] = DEF_LIB.filterTagPairs(DEF, [[key, val]]).length > 0;
    return DEF_KEEP[k];
  }
  // 価格帯（タグではなく価格から作る擬似的な軸）も同じく定義で通す。DEF が無ければ常に通す
  function defKeepsPrice(yen){
    if (!DEF) return true;
    var lo = 0, hi = null;
    for (var i = 0; i < PRICE_BANDS.length; i++){
      if (yen < PRICE_BANDS[i]) { hi = PRICE_BANDS[i]; break; }
      lo = PRICE_BANDS[i];
    }
    return defKeeps(PRICE_AXIS, hi === null ? (lo + '-') : (lo + '-' + (hi - 1)));
  }
  // 定義の選択肢の表示名・説明・画像を、VALUE_META と同じ形（l / d / i）で返す。
  // 表示名を定義に書いていないときは l を空にする（dispVal が値そのまま・価格帯の表記に落ちる）。
  // numeric と未登録の値は null（共通の filter_value は見ない）
  function defMeta(ax, v){
    var m = DEF_LIB.valueMeta(defItem(ax), v);
    if (!m) return null;
    return { l: m.label !== v ? m.label : '', d: m.desc, i: m.image };
  }

  var AXIS_LABELS   = parseMap('data-sg-axis-labels', '=');
  var SERIES_LABELS = parseMap('data-sg-series-labels', '=');
  var MAKER_LABELS  = parseMap('data-sg-maker-labels', '=');
  // 選択肢ごとの表示名・説明文・画像。登録が無い選択肢は null になる。
  var VALUE_META = (function(){
    try { return JSON.parse(root.getAttribute('data-sg-value-meta') || '{}'); }
    catch (e) { return {}; }          // 壊れていても絞り込み自体は動かす
  })();
  function vmeta(ax, v){ if (DEF) return defMeta(ax, v); return VALUE_META[ax + '||' + v] || null; }
  // 「絞り込み値」の sort_order を並び順に使う。登録が無いものは元の並びを保つ。
  function orderByMeta(ax, vals){
    var ranked = [], rest = [];
    vals.forEach(function(v){
      var m = vmeta(ax, v);
      var s = m && m.s !== undefined && m.s !== null && m.s !== '' ? Number(m.s) : null;
      if (s === null || isNaN(s)) rest.push(v); else ranked.push({ v: v, s: s });
    });
    if (!ranked.length) return vals;
    ranked.sort(function(a, b){ return a.s - b.s; });
    return ranked.map(function(x){ return x.v; }).concat(rest);
  }
  var UNITS         = parseMap('data-sg-units', ':');
  // 定義モードは項目の unit が勝つ。旧方式の材料（filter_axis・filter_order）が消えても単位を失わないため（#1016）
  if (DEF_ITEMS) Object.keys(DEF_ITEMS).forEach(function(k){ if (DEF_ITEMS[k].unit) UNITS[k] = DEF_ITEMS[k].unit; });
  var EXCLUDED      = parseList('data-sg-excluded-axes');
  // 定義モードは非表示の設定（excluded）を使わない。出す軸は定義の items だけで決まる
  if (DEF) EXCLUDED = [];
  // 固定する軸が非表示だと、build() も索引も商品行の v にその軸を入れないので、
  // 固定を掛けると全件が落ちる。その場合は固定せず、母集合側の絞り込みに任せる。
  if (PIN && EXCLUDED.indexOf(PIN.ax) >= 0) PIN = null;
  // 定義モードも同じ。固定する軸（値）が定義に無いと商品行の v から捨てられるので固定しない
  if (PIN && DEF && !defKeeps(PIN.ax, PIN.v)) PIN = null;
  // このタグが付いた商品は絞り込みの軸と、選択後の結果から外す。販売終了・お見積り商品・
  // 補修部品は「順番に選んで1つに絞る」対象ではなく、混ざると軸が増えないまま件数だけ残る。
  // 未選択時の一覧と件数には出す（標準グリッドは隠れているので、ここで落とすと一覧から消える。#902）。
  // 定義モードは外さない。出す商品は定義で決まっていて、外すと軸が「指定なし」だけになる（#948）
  var EXCLUDE_TAG   = (root.getAttribute('data-sg-exclude-tag') || '').trim();
  if (DEF) EXCLUDE_TAG = '';
  // `l1:sash-window` のような階層タグはコレクション所属を決めるための構造タグで、
  // 買い手に見せる絞り込み軸ではない。設定から外し忘れても出ないように常に落とす
  // （実際に L2 のサイドに「l1」「l2」という軸が出ていた）。
  // `col:<handle>` も同じで、切り口のコレクションの条件に使うコレクション専用のタグ（#961）。
  var STRUCTURE_AXES = ['l1', 'l2', 'l3', 'l4', 'col'];
  var NUMERIC       = parseList('data-sg-numeric-axes');
  // 寸法の軸をサイドで数値入力にする閾値。0 で無効（従来どおり一覧）。
  // 寸法の刻みを自動で決めるときの目標グループ数。0 で自動化を切る。
  var AUTO_BUCKET_TARGET = parseInt(root.getAttribute('data-sg-auto-bucket-target') || '0', 10) || 0;
  // ほかの軸で絞り込んだ残りの実寸がこの種類数以下なら、刻みではなく実寸で並べる（axValues）。
  // 12 は洗面台（ピアラ 洗面台本体 32件）の間口 9種類が入る幅。
  var FINE_MAX = 12;
  var MIN_COVERAGE  = parseFloat(root.getAttribute('data-sg-min-coverage') || '0') || 0;
  var MIN_SPLIT     = parseFloat(root.getAttribute('data-sg-min-split') || '0') || 0;
  // その軸の値を持たない商品を受け止める選択肢。
  // これが無いと「屋根材=ポリカーボネート 178件」の次で M合掌0 + Y合掌50 = 50 にしかならず、
  // 残り128件（合掌の指定が無い商品）が消えてしまう。ステップの合計は常に母数と一致させる。
  // 価格帯。タグではなく商品の価格から組み立てる擬似的な軸。
  // 先方の第1階層ガイドで「価格から選ぶ」が4カテゴリで採用されているが、
  // 価格はタグに無いのでここで作る。区切りは円。
  var PRICE_BANDS = parseList('data-sg-price-bands').map(function(x){ return parseInt(x, 10); })
    .filter(function(x){ return !isNaN(x); });
  var PRICE_AXIS = 'price';
  // 数値の軸をグループに割る幅。`W:200,H:200,L:200` の形。
  // タグに**実寸**（`W:785`）を入れておき、見せ方のグループはここで作る。
  // 刻みを変えたくなってもタグの入れ直しが要らない。
  // すでにグループ済みの値（`600-799`）を入れても同じ結果になるので、
  // 実寸へ移行する前後で表示も URL も変わらない。
  var BUCKET_W = {};
  parseList('data-sg-bucket-axes').forEach(function(pair){
    var i = pair.indexOf(':');
    if (i < 0) return;
    var k = pair.slice(0, i).trim(), w = parseInt(pair.slice(i + 1), 10);
    if (k && w > 0) BUCKET_W[k] = w;
  });
  // 定義モードの list の軸は刻まない（選択肢は定義の values そのもの。刻むのは numeric だけ）
  if (DEF) Object.keys(BUCKET_W).forEach(function(k){ if (defIsList(k)) delete BUCKET_W[k]; });
  // 単位は数値の後ろに書ける。`405` `405mm` `40.5cm` `1.2m` はすべて同じ値。
  // 軸が単位を宣言していればその単位へ、宣言が無ければmmへ寄せる。
  // 単位が書かれていない値はそのまま返す（既存データは1件も単位を持たない）。
  var UNIT_FACTOR = { mm: 1, cm: 10, m: 1000, 'ミリ': 1, 'センチ': 10, 'メートル': 1000 };
  var NUM_WITH_UNIT = /^(\d+(?:\.\d+)?)\s*(mm|cm|m|ミリ|センチ|メートル)$/i;
  function canonUnit(key, val){
    var base = UNIT_FACTOR[String(UNITS[key] || 'mm').toLowerCase()];
    if (!base) return val;                                   // 長さでない単位の軸は触らない
    var parts = String(val).split(/\s*[-–~〜]\s*/);
    if (parts.length > 2) return val;
    var out = [], hit = false;
    for (var i = 0; i < parts.length; i++){
      var m = NUM_WITH_UNIT.exec(parts[i].trim());
      if (!m) { out.push(parts[i].trim()); continue; }
      hit = true;
      var n = parseFloat(m[1]) * UNIT_FACTOR[m[2].toLowerCase()] / base;
      out.push(String(Math.round(n * 1000) / 1000));
    }
    return hit ? out.join('-') : val;
  }

  // '785' → [785,785] / '714-977' → [714,977]
  function numRange(v){
    // 小数も受ける。先方が「間口182.4cm」のように小数で指定する軸があり、
    // 整数しか受けないと**その値だけ帯に入らず単独で並ぶ**（TIO の間口で
    // `90〜99cm` と `92.4cm` が混ざっていた）。
    var m = String(v).match(/^\s*(\d+(?:\.\d+)?)\s*(?:[-–~〜]\s*(\d+(?:\.\d+)?))?\s*$/);
    if (!m) return null;
    var lo = parseFloat(m[1]);
    return [lo, m[2] ? parseFloat(m[2]) : lo];
  }
  // 定義の numeric 項目に書いた区分（`ranges: ["300-650", "651-750"]`。#953）。
  // 等間隔の刻み（BUCKET_W）では先方指定の区分が作れないので、書いた軸は刻みより区分を優先する。
  // 区分の文字列がそのまま選択肢の値（URL・件数のキー）で、書いた順が並び順。
  // 返すのは [{ v: '300-650', lo: 300, hi: 650 }]。区分を書いていない軸は null（従来の刻み）。
  var OTHER_VALUE = '__other__';
  var OTHER_LABEL = 'その他';
  var RANGES_CACHE = Object.create(null);
  function rangesOf(key){
    if (!DEF) return null;
    if (key in RANGES_CACHE) return RANGES_CACHE[key];
    var it = defItem(key), out = null;
    if (it && it.show === 'numeric' && Object.prototype.toString.call(it.ranges) === '[object Array]'){
      out = [];
      it.ranges.forEach(function(s){
        var r = numRange(s);
        if (r && r[0] <= r[1]) out.push({ v: String(s).trim(), lo: r[0], hi: r[1] });
      });
      if (!out.length) out = null;
    }
    return (RANGES_CACHE[key] = out);
  }
  // 刻み・区分のどちらかで、タグの生値ではなくまとめた値を選択肢にしている軸か
  function isBucketed(key){ return !!(rangesOf(key) || BUCKET_W[key]); }
  // その値がまたがるグループを全部返す。可変寸法（注文サイズ）はどの幅でも作れるので
  // 範囲に重なるグループすべてに入れるのが正しい。
  // 区分を書いた軸も同じ: 実寸（`W:785`）は含む区分に、範囲（`W:714-977`）は重なる区分すべてに。
  // どの区分にも入らない値（数値でない値も）は「その他」へ。
  function bucketsOf(key, v){
    var rs = rangesOf(key);
    if (rs){
      var rr = numRange(v), hit = [];
      if (rr) rs.forEach(function(g){ if (g.lo <= rr[1] && rr[0] <= g.hi && hit.indexOf(g.v) < 0) hit.push(g.v); });
      return hit.length ? hit : [OTHER_VALUE];
    }
    var w = BUCKET_W[key];
    if (!w) return [v];
    var r = numRange(v);
    if (!r) return [v];
    var out = [], start = Math.floor(r[0] / w) * w, end = Math.floor(r[1] / w) * w;
    if ((end - start) / w > 40) return [v];        // 桁違いの値は触らない（誤検出よけ）
    for (var x = start; x <= end; x += w) out.push(x + '-' + (x + w - 1));
    return out;
  }

  // 刻みに入れた寸法の実寸。商品の値の配列に `=1694` の形で刻みと並べて持たせる。
  //
  // なぜ要るか（2026-09-30 先方確認・別紙）: 刻みはページを開いた時点の全商品で決まり、
  // 絞り込んでも変わらない。YKKap（7,115件・500mm刻み）で「店舗引戸 STH-3」を選ぶと
  // 残り3件の幅 1694 / 1800 / 1897 が全部「1500〜1999mm」に入り、選んでも減らないので
  // 幅の項目ごと消えていた。残りの寸法が数種類なら実寸で並べたほうが選べる。
  //
  // 先頭の `=` で刻みの値（`1500-1999`）と区別する。実寸は選択肢の一覧（ax.values）には
  // 入れないので、既存の件数・焼き込み・URL の扱いは刻みのまま変わらない。
  //
  // 区分（ranges）を書いた軸は対象外（#955）。先方が「この区分で並べる」と決めた軸なので、
  // 残りの種類数に関係なく区分のまま出す。実寸を作らないので、古い URL の `f.幅==648` は無視される。
  var FINE_PREFIX = '=';
  function isFine(v){ return typeof v === 'string' && v.charAt(0) === FINE_PREFIX; }
  function fineOf(key, v){
    if (rangesOf(key) || !BUCKET_W[key] || !numRange(v)) return null;
    return FINE_PREFIX + v;
  }

  // 寸法の刻みを自動で決める。
  //
  // 実寸のタグ（`W:785`）をそのまま選択肢にすると幅が900種類を超えるので、
  // 以前は数値入力にしていた。数値入力は「いくつを打てばいいか」が分からないので、
  // **刻みのほうを商品の広がりに合わせて決める**。
  //   - 刻みは切りのいい候補（50/100/200/250/500/1000/...）から選ぶ
  //   - できるグループ数が目標（既定8）に最も近いものを採る。同点なら細かい側
  //   - 商品が無いグループは選択肢に出ない（build 側が値の集合から作るため）
  // 手で `bucket_axes` に刻みを書いた軸はそのまま尊重する。
  var PITCH_LADDER = [10, 20, 25, 50, 100, 150, 200, 250, 300, 500, 1000, 2000, 2500, 5000, 10000];
  // 刻みは「軸ごとに、どんな値が出てくるか」だけで決まる。商品を1件ずつ見る必要はない。
  // なので値の集め方（商品から / 焼き込みの集計から）と、刻みの決め方を分けてある。
  // 分けないと焼き込み側で同じ判定をもう一度書くことになり、片方だけ直したときに黙って食い違う。
  function collectRawValue(raw, key, val){
    if (!key || !val) return;
    if (BUCKET_W[key] || rangesOf(key)) return;   // 手で刻み・区分を決めている軸は触らない
    if (EXCLUDED.indexOf(key) >= 0 || STRUCTURE_AXES.indexOf(key) >= 0) return;
    if (DEF && (!defItem(key) || defIsList(key))) return;   // 定義モードで刻みを自動で決めるのは numeric だけ
    var r = numRange(canonUnit(key, val));
    if (!r) { raw[key] = null; return; }          // 数値でない値が混ざる軸は対象外
    if (raw[key] === null) return;
    (raw[key] = raw[key] || {})[r[0]] = 1;
  }
  function pitchFromRaw(raw){
    Object.keys(raw).forEach(function(key){
      var set = raw[key];
      if (!set) return;
      var vals = Object.keys(set).map(Number);
      if (vals.length <= AUTO_BUCKET_TARGET) return;   // そのまま並べても選びやすい
      var best = null;
      PITCH_LADDER.forEach(function(w){
        var groups = {};
        vals.forEach(function(x){ groups[Math.floor(x / w)] = 1; });
        var n = Object.keys(groups).length;
        if (n < 2) return;                             // 1グループでは絞り込みにならない
        var score = Math.abs(n - AUTO_BUCKET_TARGET);
        if (!best || score < best.score) best = { w: w, n: n, score: score };
      });
      if (best) BUCKET_W[key] = best.w;
    });
  }
  function autoBucketWidths(products){
    if (!AUTO_BUCKET_TARGET) return;
    var raw = {};                                   // key -> { 値の下限: 1 }
    products.forEach(function(p){
      (p.tags || []).forEach(function(tag){
        var i = tag.indexOf(':');
        if (i < 0) return;
        collectRawValue(raw, tag.slice(0, i).trim(), tag.slice(i + 1).trim());
      });
    });
    pitchFromRaw(raw);
  }
  // 焼き込みの集計版。入る値の集合は商品を全部見たときと同じなので、同じ刻みになる。
  //
  // ⚠️ ここで決めた刻みは BUCKET_W に残り、あとから走る autoBucketWidths(products) は
  // 「手で刻みを決めている軸」とみなして**上書きしない**。これは意図した挙動:
  // 焼き込みは全商品から刻みを決めるのに対し、母集合は取得上限（MAX_PAGES）で
  // 切られていることがある。刻みが途中で変わると、同じページで選択肢の切り方が
  // 入れ替わって見える。焼き込み側（全件）の刻みで通したほうが一貫する。
  function autoBucketWidthsFromDigest(dg){
    if (!AUTO_BUCKET_TARGET) return;
    var raw = {};
    Object.keys(dg.axes).forEach(function(key){
      Object.keys(dg.axes[key].v || {}).forEach(function(combo){
        // キーは「1商品がその軸に持つ値の組」。刻みは生値の集合から決まるので分解する
        combo.split(VALUE_SEP).forEach(function(val){ collectRawValue(raw, key, val); });
      });
    });
    pitchFromRaw(raw);
  }
  var NONE_VALUE = '__none__';
  var NONE_LABEL = '指定なし';
  var MAX_AXES      = parseInt(root.getAttribute('data-sg-max-axes') || '0', 10) || 0;
  var TOTAL         = parseInt(root.getAttribute('data-sg-count') || '0', 10) || 0;
  var LAYOUT_MODE   = root.getAttribute('data-sg-layout-mode') || 'auto';
  var RENDER_CHUNK  = parseInt(root.getAttribute('data-sg-render-chunk') || '48', 10) || 48;
  // 会員特別価格（PDP・通常カードと同じ率。snippets/price.liquid 参照）。
  var CUSTOMER_TAGS = (root.getAttribute('data-sg-customer-tags') || '').split(',').map(function(t){ return t.trim(); }).filter(Boolean);
  var LOGGED_IN     = root.getAttribute('data-sg-logged-in') === 'true';
  var MEMBER_RANKS  = [
    { tag: 'member_diamond', label: 'ダイヤモンド会員価格', rate: 0.93 },
    { tag: 'member_gold',    label: 'ゴールド会員価格',     rate: 0.94 },
    { tag: 'member_silver',  label: 'シルバー会員価格',     rate: 0.95 },
    { tag: 'member_bronze',  label: 'ブロンズ会員価格',     rate: 0.97 }
  ];
  function floor100(v){ return Math.floor(v / 100) * 100; }
  // basePrice … 当店価格（円）。bronzePrice … バリアントの custom.bronze_price（円・生値）。
  //
  // **ブロンズはメタフィールドの生値をそのまま出す。**率で計算し直さない
  // （snippets/price.liquid のサーバ描画と同じ値。加工すると初期描画と食い違う）。
  // 値が無い商品と、メタフィールドを運べない経路（/collections/{handle}/products.json
  // フォールバック・焼き込み索引だけで描いた行）は従来どおり率の計算値に落ちる。
  function memberPrice(basePrice, bronzePrice){
    var base = parseFloat(basePrice);
    if (!base || base <= 0) return null;
    var bronze = parseFloat(bronzePrice);
    if (!bronze || bronze <= 0) bronze = null;
    if (LOGGED_IN) {
      // シルバー以上のタグが無ければブロンズ（snippets/price.liquid と同じ・#794）。
      var rank = MEMBER_RANKS.filter(function(r){ return CUSTOMER_TAGS.indexOf(r.tag) !== -1; })[0]
        || MEMBER_RANKS.filter(function(r){ return r.tag === 'member_bronze'; })[0];
      var val = (rank.tag === 'member_bronze' && bronze !== null) ? bronze : floor100(base * rank.rate);
      return val > 0 ? { label: rank.label, price: val } : null;
    }
    // 未ログインは自分のランクが分からないので、カードでは一番低いランク（ブロンズ）を見せる。
    // メタフィールドがあればその生値。無いときの率は上の MEMBER_RANKS から引く
    // （ハードコードしない）。Liquid 初期描画の render 'price' に渡す
    // member_guest_rate: 0.97 と同じ値でなければ、初期描画と絞り込み・検索の再描画で
    // 金額が食い違う（issue #642）。
    var guestRank = MEMBER_RANKS.filter(function(r){ return r.tag === 'member_bronze'; })[0];
    // 行を出すかの判定はダイヤモンド基準にする。snippets/price.liquid のガードが
    // diamond_yen > 0 なので、ここをブロンズ基準にすると当店価格 ¥102〜¥105 だけ
    // 初期描画は行なし・絞り込みと検索の再描画は ¥100 になって食い違う。
    // どちらの基準に統一するかは issue #642 の派生タスク（人の判断待ち）。
    var diamondRank = MEMBER_RANKS.filter(function(r){ return r.tag === 'member_diamond'; })[0];
    if (floor100(base * diamondRank.rate) <= 0) return null;
    return { label: '会員価格', price: bronze !== null ? bronze : floor100(base * guestRank.rate) };
  }
  // pending … 骨のカード（索引の行だけで、表示項目が未着）。索引は bronzePrice を持たないので、
  // ここで会員価格を出すと率の計算値（100円切り捨て）が一瞬見えてから custom.bronze_price
  // （1円単位）に書き換わる。届くまで会員価格の行は出さない。
  function priceRowsHtml(p, pending){
    var rows = '';
    if (p.compareAtPrice && parseFloat(p.compareAtPrice) > parseFloat(p.price)) {
      rows += '<div class="price-rows__row price-rows__row--listed"><span class="price-rows__label">メーカー希望価格</span><span class="compare-at-price">' + yen(p.compareAtPrice) + '</span></div>';
    }
    // 送料は会員価格の後ろに独立した行として置く（Liquid 初期描画の snippets/price.liquid に
    // shipping_fee_position: 'after_member' を渡したときと同じ並び）。当店価格の行に混ぜると
    // .sg-card では行内で折り返して当店価格と会員価格の間に落ちる（issue #628）。
    // 0 は「送料込」の実データなので null（未設定）と区別する。
    var feeHtml = '';
    if (p.shippingPrice != null) {
      var fee = parseFloat(p.shippingPrice);
      feeHtml = fee > 0
        ? '<span class="price-shipping-fee"><span class="price-shipping-fee__label">送料</span><span class="price-shipping-fee__amount">＋' + yen(fee) + '</span></span>'
        : '<span class="price-shipping-fee price-shipping-fee--free"><span class="price-shipping-fee__amount">送料込</span></span>';
    }
    rows += '<div class="price-rows__row price-rows__row--selling"><span class="price-rows__label">当店価格</span><span class="price">' + yen(p.price) + '</span><span class="price-rows__tax">(税込)</span></div>';
    var mp = pending ? null : memberPrice(p.price, p.bronzePrice);
    if (mp) {
      rows += '<div class="price-rows__row price-rows__row--member"><span class="price-rows__label">' + mp.label + '</span><span class="member-price">' + yen(mp.price) + '</span><span class="price-rows__tax">(税込)</span></div>';
    }
    // 会員価格が出ないとき（未ログインで金額が0円など mp が null）も送料は消さない。
    if (feeHtml) {
      rows += '<div class="price-rows__row price-rows__row--shipping">' + feeHtml + '</div>';
    }
    // カードではログイン導線は場所を取りすぎるため出さない（PDPのみ表示）。
    return '<div class="price-rows">' + rows + '</div>';
  }

  // ウィザード（step）かサイドのみ（flat）か。
  //
  // 以前は handle のハイフン数を階層の代わりに使っていたが、L1 のハンドル自体に
  // ハイフンがある系統（sash-window / entrance-door / building-materials）では
  // その L2（sash-window-mado）が 2 個になり L3 と区別できなかった。
  // 階層はテンプレート割当（l1-category-top / 既定 / l3-l4-step-guide）が持っているので
  // セクション設定から受け取る。auto は設定を触っていないテンプレート向けの後方互換。
  function resolveMode(axisCount){
    if (DEF) return DEF_LIB.mode(DEF);        // 定義モードは定義の形式だけで決める（ハンドル・軸数を見ない）
    if (axisCount < 2) return 'flat';        // 軸が1つならウィザードにする意味がない
    if (LAYOUT_MODE === 'step' || LAYOUT_MODE === 'flat') return LAYOUT_MODE;
    return (handle.match(/-/g) || []).length >= 2 ? 'step' : 'flat';
  }

  var AXIS_SORT     = parseMap('data-sg-axis-sort', '=');

  // 並び順のキー。小さいほど先。
  //   1. sort_order のある軸 → band 順（種類10番台 → 納まり200番台 → 寸法300番台 →
  //      メーカー400番台 → 仕様500番台 → 意匠700番台 → 価格900）
  //   2. sort_order も無い軸 → 選択肢が少ない順で末尾
  // 以前は STEP 表（filter_order）の順を先に見ていたが #1018 で読まなくなった。
  function orderKey(axis){
    var band = parseInt(AXIS_SORT[axis.key], 10);
    if (isNaN(band)) return 1e9 + axis.values.length;
    return Math.min(band, 999);
  }

  // ---- Ajax API から公開商品を全件取る ----------------------------------
  // limit の実効上限は 250。ページが尽きるまで並列で追いかける。
  // Admin API より件数が少なくなるのは、このエンドポイントが公開商品だけを
  // 返すため。絞り込みの母集合としてはそちらが正しい。
  // 検索は Liquid の paginate 上限があるため 50 件/ページ。コレクションの Ajax API は 250。
  var PAGE_SIZE = SOURCE === 'search' ? 50 : 250;

  // 検索側のデータは search-products-json セクションが出す。1ページ目はページ内に
  // 埋まっているので取得不要。2ページ目以降は Section Rendering API で同じ
  // セクションだけを描かせて読む（検索には products.json も ?view= も無い）。
  // このスクリプトはセクションの位置でそのまま走るため、データ供給セクションが
  // 後ろに置かれていると読めない。参照は使うときに引く。
  function sgData(){ return document.querySelector('[data-sg-products]'); }
  function sgSectionId(){
    var el = sgData();
    var host = el && el.closest('.shopify-section');
    return host && host.id ? host.id.replace(/^shopify-section-/, '') : '';
  }
  function readSgJson(el){
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  // ⚠️ 母集合を追っている途中で Shopify のレート制限に当たると、429 と
  // 「Verifying your connection...」のHTMLが返る。`r.ok` で空配列に倒すと
  // 呼び出し側が「カタログが尽きた」と読んで打ち切るので、集めきれていないのに
  // 軸と件数を確定させてしまう（実測: 面格子 3,501件が 1,000件で止まった）。
  // 待ってから数回だけ取り直し、それでも駄目なら FETCH_INCOMPLETE を立てて
  // 「集めきれていない」ことを呼び出し側へ伝える。
  var FETCH_INCOMPLETE = false;
  // `?view=sgdata` は毎レスポンスで権威あるページ総数 `pages` を返している
  // （templates/collection.sgdata.liquid）。429 の記録は「失敗に気付けた」ときにしか
  // 立たないので、集めた件数がその総数に見合うかでも裏を取る。
  // 0 は「まだ受け取っていない」＝検索経路や products.json だけで来た場合。
  var SGDATA_PAGES = 0;
  function fetchSearchPage(page, attempt){
    if (page === 1) {
      var inline = readSgJson(sgData());
      if (inline) return Promise.resolve(inline.products || []);
    }
    var sid = sgSectionId();
    if (!sid) return Promise.resolve([]);
    var tries = attempt || 0;
    var url = '/search?q=' + encodeURIComponent(QUERY) + '&type=product&page=' + page
      + '&section_id=' + encodeURIComponent(sid);
    return fetch(url)
      .then(function(r){
        if (r.status === 429 || r.status === 430 || r.status >= 500) {
          if (tries >= 3) { FETCH_INCOMPLETE = true; return ''; }
          var wait = 500 * Math.pow(2, tries);   // 0.5s → 1s → 2s
          return new Promise(function(res){ setTimeout(res, wait); })
            .then(function(){ return fetchSearchPage(page, tries + 1); });
        }
        return r.ok ? r.text() : '';
      })
      .then(function(htmlOrList){
        if (!htmlOrList) return [];
        if (typeof htmlOrList !== 'string') return htmlOrList;   // リトライの結果
        var doc = new DOMParser().parseFromString(htmlOrList, 'text/html');
        var parsed = readSgJson(doc.querySelector('[data-sg-products]'));
        return (parsed && parsed.products) || [];
      })
      .catch(function(){ FETCH_INCOMPLETE = true; return []; });
  }
  // コレクション側は専用テンプレート `?view=sgdata`（templates/collection.sgdata.liquid）から取る。
  // `products.json` は1商品あたり全バリアント・全画像を返すので実測 2.2KB/商品
  // （250商品で 581KB）。使うのはタグ・タイトル・価格・画像1枚・vendor だけなので、
  // 同じ形の軽いJSONを自前で出す（実測 37〜40%）。paginate は 250 まで指定できるので
  // リクエスト数は変わらない。
  //
  // テンプレートが無いテーマ（過去バージョンへの巻き戻しなど）でも動くように、
  // JSON として読めなかったら products.json に落ちる。
  // HTMLに埋め込まれた母集合（250商品以下のページ）。あればネットワークを使わない。
  function inlineProducts(){
    var el = document.querySelector('[data-sg-inline-products]');
    if (!el) return null;
    try {
      var j = JSON.parse(el.textContent);
      return (j && j.products && j.products.length) ? j.products : null;
    } catch (e) { return null; }
  }

  function fetchPage(page, attempt){
    if (SOURCE === 'search') return fetchSearchPage(page);
    if (page === 1) {
      var inline = inlineProducts();
      // 埋め込みは全件（250件以下のページにしか出さない）。追いかけない。
      if (inline) return Promise.resolve(inline);
    }
    // ⚠️ コレクション側も検索側と同じレート制限の下にある。429 を `r.ok` で空に倒すと
    // 呼び出し側から「カタログが尽きた」と区別が付かず、欠けた母集合のまま件数と軸が
    // 確定する（実測: 19,586件の sash-window が 1,209件で確定した）。待ってから
    // 数回だけ取り直し、それでも駄目なら FETCH_INCOMPLETE を立てる。
    // 取り直しに失敗したときは products.json には落とさない——同じレート制限下なので
    // そちらも 429 を返すだけで、リクエストを倍にして制限を深めるだけになる。
    var tries = attempt || 0;
    return fetch('/collections/' + handle + scopePath() + '?view=sgdata&page=' + page)
      .then(function(r){
        if (r.status === 429 || r.status === 430 || r.status >= 500) {
          if (tries >= 3) { FETCH_INCOMPLETE = true; return { products: [] }; }
          var wait = 500 * Math.pow(2, tries);   // 0.5s → 1s → 2s
          return new Promise(function(res){ setTimeout(res, wait); })
            .then(function(){ return fetchPage(page, tries + 1); })
            .then(function(list){ return { products: list }; });   // 取り直しの結果
        }
        // ok でない＝テンプレートが無いテーマ（404）など。products.json に落ちる
        if (!r.ok) return null;
        return r.text().then(function(text){
          try { return JSON.parse(text); } catch (e) { return null; }
        });
      })
      .then(function(j){
        // ページ総数は毎レスポンスに入っている。1本でも 200 が返れば以降の判定に使える
        if (j && typeof j.pages === 'number' && j.pages > SGDATA_PAGES) SGDATA_PAGES = j.pages;
        if (j && j.products) return j.products;
        return fetchPageLegacy(page);
      })
      .catch(function(){ return fetchPageLegacy(page); });
  }

  function fetchPageLegacy(page){
    // ⚠️ products.json も同じレート制限の下にあるので、ここが空で返るのは
    // 「カタログが尽きた」ではなく「取れなかった」ことの方が多い。黙って空を返すと
    // 呼び出し側から区別が付かないので、失敗は必ず FETCH_INCOMPLETE に残す。
    return fetch('/collections/' + handle + '/products.json?limit=' + PAGE_SIZE + '&page=' + page)
      .then(function(r){
        if (!r.ok) { FETCH_INCOMPLETE = true; return { products: [] }; }
        return r.json();
      })
      .then(function(j){
        var list = (j && j.products) || [];
        // products.json はタグで絞れない。メーカー指定があれば手元で落とす。
        // 落とすとページが短くなり fetchRest() が「尽きた」と読むので、集めきれていない扱いにする
        if (SCOPE_TAG && list.length) {
          var want = SCOPE_TAG.toLowerCase();
          list = list.filter(function(p){
            var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
            return tags.some(function(t){ return String(t).trim().toLowerCase() === want; });
          });
          FETCH_INCOMPLETE = true;
        }
        return list;
      })
      .catch(function(){ FETCH_INCOMPLETE = true; return []; });
  }
  // all_products_count は非公開分も数えるので、実際のページ数はこれより少ないことも
  // 多いこともある（公開商品が非公開分を上回る並びだと足りなくなる）。最後のページが
  // 埋まっている間は 4 ページずつ追い、尽きるまで繰り返す。
  // MAX_PAGES は暴走止め。コレクションは 250 × 40 ＝ 10,000件、検索は 50 × 200 で
  // 同じ 10,000件に揃えてある（以前は検索だけ 40ページ＝2,000件で、面格子のような
  // 数千件の検索語がガイドに乗らずコレクションと見た目が食い違っていた）。
  var MAX_PAGES = SOURCE === 'search' ? 200 : 40;
  var CHASE = 4;
  // 1ページ目は立ち上げ側が先に取って商品を描くので、ここは**2ページ目以降だけ**を追う。
  // 1ページ目を渡すと、それを先頭に置いた全件を返す。
  // ⚠️ 429 の記録（fetchPage / fetchPageLegacy）は失敗に気付けたときにしか立たない。
  // 200 で本文だけが短い・途中のページが静かに空で返る、といった取りこぼしは素通りする。
  // `pages` が権威なので、最終ページ以外を埋められていなければ集めきれていないと決める
  // （焼き込み側 scripts/bake_facet_axes.py:305 と同じ判定。あちらは例外で止め、
  //   こちらは FETCH_INCOMPLETE に倒して件数を焼き込みへ譲る）。
  function checkAgainstPages(list){
    if (!SGDATA_PAGES) return list;                       // pages を受け取っていない経路
    if (list.length < (SGDATA_PAGES - 1) * PAGE_SIZE) FETCH_INCOMPLETE = true;
    return list;
  }

  // onChunk（任意）… CHASE 本ぶん届くたびに、そのバッチの商品を渡す。全ページ揃うのを
  // 待たずに骨のカードを埋めるため（2〜4ページ目の商品が全40ページ待ちで5秒骨のままだった）。
  function fetchRest(first, onChunk){
    var expected = TOTAL ? Math.ceil(TOTAL / PAGE_SIZE) : 1;
    var all = first.slice();
    // 埋め込みで来た＝250件以下のページなので、それが全件
    if (INLINE_USED) return Promise.resolve(all);
    // 1ページ目で尽きているなら追わない（pages が 2 以上を主張しているなら取りこぼし）
    if (first.length < PAGE_SIZE) return Promise.resolve(checkAgainstPages(all));
    // ⚠️ 予想ページ数を一度に Promise.all へ流すと、10,000件級で 200 本のリクエストが
    // 同時に飛ぶ。ブラウザの同時接続数で直列化はされるが Shopify 側のバースト判定に
    // 当たると 429 で欠けたまま軸を組んでしまう。最初のぶんも CHASE 単位で刻む。
    var next = 2;
    var lastChunk = first;
    var limit = Math.min(Math.max(expected, 2), MAX_PAGES);
    function chase(last){
      // MAX_PAGES で打ち切った時点では、カタログが尽きたことを確認できていない。
      // 「最後のページが埋まっていたら続きがある」という判定は、レート制限で最後の
      // ページが空になると成立せず、上限に達したことすら記録されなかった（#627）。
      // 空が「尽きた」なのか「取れなかった」なのかは fetchPage() / fetchPageLegacy() が記録する。
      if (next > MAX_PAGES) FETCH_INCOMPLETE = true;
      // 最後に取れたページが埋まっていなければ、そこでカタログが尽きている
      if (!last || last.length < PAGE_SIZE || next > MAX_PAGES) return all;
      var batch = [];
      // 予想ページ数までは埋まっていなくても取りに行く（途中に商品以外が
      // 混ざるページがあると 50 未満で返ることがあり、そこで打ち切ると足りなくなる）
      var stop = next <= limit ? limit : MAX_PAGES;
      for (var j = 0; j < CHASE && next <= stop; j++) batch.push(next++);
      if (!batch.length) return all;
      // ⚠️ `map(fetchPage)` は第2引数に配列の添字を渡す＝リトライ回数として読まれ、
      // バッチの4本目が1度も取り直さずに諦める。ページ番号だけを渡す。
      return Promise.all(batch.map(function(p){ return fetchPage(p); })).then(function(more){
        var got = [];
        more.forEach(function(c){ all = all.concat(c); got = got.concat(c); });
        if (onChunk && got.length) { try { onChunk(got); } catch (e) {} }
        var tail = more[more.length - 1];
        // 予想ページ数の範囲内は、途中で空が返っても次のバッチへ進む
        if (next <= limit) return chase(tail && tail.length ? tail : first);
        return chase(tail);
      });
    }
    return Promise.resolve(chase(lastChunk)).then(checkAgainstPages);
  }

  // 母集合の1ページ目。立ち上げと遅延取得で**同じ1本**を使い回す
  // （別々に呼ぶと同じページを2回取る）。
  var FIRST_PAGE = null;
  function firstPage(){
    if (!FIRST_PAGE) FIRST_PAGE = fetchPage(1);
    return FIRST_PAGE;
  }

  // 全件ぶんの表示項目を取りに行く。**needsFullDisplay() が真になったときだけ呼ぶ。**
  // 索引だけで答えが出るあいだは1本も飛ばさない（従来はこれを立ち上げで無条件に走らせ、
  // sash-window で 40リクエスト・0.98MB を毎回払っていた / issue #811）。
  //
  // 2回目以降は同じ Promise を返す。MAX_PAGES 打ち切りで DISPLAY_FULL が立たなかった
  // ときも取り直さない。取り直しても同じところで打ち切るだけ。
  var POOL_CHASE = null;
  function ensureDisplayPool(){
    // ⚠️ **立ち上げ前は呼ばない。** PAGE_SIZE / TOTAL はこの下で代入されるので、
    // それより前に入ると `limit=undefined` の URL を叩く。並び替えの初期同期
    // （Firefox の select 復元）がここを踏む。立ち上げ側が改めて拾う。
    if (!BOOTED) return Promise.resolve(null);
    if (DISPLAY_FULL) return Promise.resolve(null);
    if (POOL_CHASE) return POOL_CHASE;
    beginFetch();
    POOL_CHASE = firstPage().then(function(first){
      if (!first || !first.length) return null;
      // 索引経路では、届いたバッチの絵をその場で覚えて一覧だけ描き直す。
      // 画面に出ている分が揃っていれば描き直さない（数えるのは索引なので件数は動かない）。
      return fetchRest(first, function(chunk){
        learnLiveOrder(chunk);   // バッチはページ順に届く＝いまの並びの続き
        if (!INDEX_ROWS || DISPLAY_FULL) return;
        var covered = displayCoversShown();
        rememberDisplay(build(chunk).products);
        if (!covered) repaintIndex();
      });
    }).catch(function(){ return null; }).then(function(all){
      endFetch();
      // activate() は索引経路では rememberDisplay と DISPLAY_FULL の更新、
      // repaintIndex() だけをして返る（軸と件数は索引が持っている）。
      if (all && all.length) activate(all);
      updateTextSearchStatus();
      return all;
    });
    return POOL_CHASE;
  }

  // 母集合を**1ページずつ**足す。「さらに表示」で伸ばしたぶんの絵が足りず、
  // かつタグでは引けない（実タグの軸が選ばれていない）ときの道。
  // 全ページ追う fetchRest() は使わない。
  var poolPage = 1, poolPaging = false;
  function chasePoolPage(){
    if (poolPaging || DISPLAY_FULL || POOL_CHASE) return;
    if (poolPage >= MAX_PAGES) return;
    poolPaging = true;
    beginFetch();
    fetchPage(++poolPage).then(function(list){
      poolPaging = false;
      endFetch();
      if (!list || !list.length) { poolPage = MAX_PAGES; return; }
      learnLiveOrder(list);
      rememberDisplay(build(list).products);
      renderResults();
      if (!displayCoversShown()) chasePoolPage();
    }).catch(function(){ poolPaging = false; endFetch(); });
  }

  // ---- 検索語・検索対象の表記ゆれ吸収 ------------------------------------
  // 検索語（TEXT_Q）と検索対象（searchText）の**両方に同じものを通す**。片方だけ通すと
  // 逆向きに食い違って、打った側が正規化されていない語だけ静かに 0 件になる。
  // 規則は素の一覧側（snippets/collection-text-filter.liquid の normalize()）と揃える:
  //   NFKC（半角カナ `ﾗｼｯｻ` → 全角カナ `ラシッサ`・濁点も `ﾊﾞ` → `バ` に合成 /
  //   全角英数 `ＬＶ０１` → 半角 / 全角空白 → 半角）→ 小文字化 → 全角カタカナ → ひらがな
  //   → 前後の空白を落とす。
  // NFKC を小文字化より先に回すこと。逆だと全角の `Ａ` が `ａ` のまま残って半角に落ちない。
  // カタカナをひらがなに寄せるので、`ラシッサ`・`ﾗｼｯｻ`・`らしっさ` が同じ文字列になる。
  // ⚠️ ガイド側の正規化はこれ1本だけ。入力側（TEXT_Q）用に別実装を作らないこと。
  // ⚠️ 素の一覧側の normalize() と**同じ規則**であることが前提。片方を変えるときは両方を変える。
  function normText(s){
    return String(s == null ? '' : s)
      .normalize('NFKC')
      .toLowerCase()
      .replace(/[\u30A1-\u30F6]/g, function(m){ return String.fromCharCode(m.charCodeAt(0) - 0x60); })
      .trim();
  }

  // ---- タグ `軸:値` から axes / products を組み立てる --------------------
  // 規則（どの軸を出すかは axesFrom() が決める）:
  //   選択肢が1つしかない軸は落とす / カバー率が min_coverage 未満は落とす /
  //   並び順は orderKey()（axis_config の sort → 選択肢が少ない順）
  function numericKey(v){
    var m = String(v).match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : Number.MAX_SAFE_INTEGER;
  }
  function build(products){
    var values = {}, holders = {}, rows = [], axisRows = [];
    // 除外タグの商品は**行としては残す**（x: true）。未選択時の一覧と件数には出す。
    // 軸の材料（刻み・values・holders・total）にはタグの無い商品だけを使う。
    // ⚠️ ここで products から落とすと、戻り値が一覧にも使われるので一覧からも消える（#902）。
    // 選択後の結果・件数から外すのは matches() / countsFor() 側が x を見てやる。
    function excluded(p){
      return !!EXCLUDE_TAG && (p.tags || []).indexOf(EXCLUDE_TAG) >= 0;
    }
    var axisProducts = products.filter(function(p){ return !excluded(p); });
    // 刻みは「この商品群にどれだけ寸法の広がりがあるか」で決まるので、
    // 値を割り当てる前に一度だけ全商品のタグを見て確定させる
    autoBucketWidths(axisProducts);
    products.forEach(function(p){
      var v = {}, seen = {}, x = excluded(p);
      (p.tags || []).forEach(function(tag){
        var i = tag.indexOf(':');
        if (i < 0) return;                                   // プレフィックス無しの運用タグ
        var key = tag.slice(0, i).trim(), val = tag.slice(i + 1).trim();
        if (!key || !val || EXCLUDED.indexOf(key) >= 0) return;
        if (STRUCTURE_AXES.indexOf(key) >= 0) return;         // 階層タグは絞り込み軸ではない
        val = canonUnit(key, val);                            // `405mm` を `405` に寄せる
        // 定義モード: 定義外の key・list の未登録値は捨てる（単位を寄せた値で定義と突き合わせる）
        if (DEF && !defKeeps(key, val)) return;
        // 1商品が同じ軸に複数の値を持つことがある。上書きすると片方が消える:
        //   可変寸法 … `W:714-977` は 600-799 と 800-999 の両方のグループに入る
        //   シリーズ … L4の商品は親（L3）のシリーズタグも持つ（フーゴ ⊂ カーポート）
        var vals_ = bucketsOf(key, val);
        for (var bi_ = 0; bi_ < vals_.length; bi_++){
          var bv_ = vals_[bi_];
          if ((v[key] || []).indexOf(bv_) >= 0) continue;
          (v[key] = v[key] || []).push(bv_);
          if (x) continue;
          values[key] = values[key] || {};
          values[key][bv_] = 1;
        }
        // 刻みに入れた寸法は実寸も持たせる（選択肢の一覧 values には入れない）。
        // 絞り込んで残りが少なくなったときに実寸で選べるようにするため（fineValues）。
        var fv_ = fineOf(key, val);
        if (fv_ && v[key].indexOf(fv_) < 0) v[key].push(fv_);
        if (!x && !seen[key]) { holders[key] = (holders[key] || 0) + 1; seen[key] = 1; }
      });
      var variant = (p.variants || [])[0] || {};
      // 価格帯を疑似タグとして持たせる（`price:100000-199999` 相当）
      if (PRICE_BANDS.length){
        var yen = parseFloat(variant.price);
        if (!isNaN(yen) && yen > 0 && defKeepsPrice(yen)){
          var lo = 0, hi = null;
          for (var bi = 0; bi < PRICE_BANDS.length; bi++){
            if (yen < PRICE_BANDS[bi]) { hi = PRICE_BANDS[bi]; break; }
            lo = PRICE_BANDS[bi];
          }
          var band = hi === null ? (lo + '-') : (lo + '-' + (hi - 1));
          (v[PRICE_AXIS] = v[PRICE_AXIS] || []).push(band);
          if (!x) {
            values[PRICE_AXIS] = values[PRICE_AXIS] || {};
            values[PRICE_AXIS][band] = 1;
          }
          if (!x && !seen[PRICE_AXIS]) { holders[PRICE_AXIS] = (holders[PRICE_AXIS] || 0) + 1; seen[PRICE_AXIS] = 1; }
        }
      }
      var img = (p.images || [])[0];
      // 商品名での検索用。正規化して1回だけ作る（毎回 normText すると重い）。
      // タイトル・メーカーだけでなく **タグ・商品タイプ・SKU** も混ぜる。素の一覧側の
      // `data-search-meta`（sections/main-collection.liquid:91-98）と同じ顔ぶれにして、
      // 同じ語で同じ結果が出るようにする。タグの `軸:値` は `:` を空白に開いて、
      // `series:ラシッサd` の値だけでも語として引けるようにする（素の一覧側と同じ）。
      // ⚠️ キー名は母集合3経路が出しているものと**そのまま**合わせること。
      // `product_type`（商品タイプ）と `variants[0].sku`（代表バリアントのSKU）で、
      // どちらも products.json の呼び方。`p.type` / `p.sku` では永久に undefined になり、
      // SKU・商品タイプで引けないまま静かに素通りする。
      // まだ焼き直していない古い母集合には両方とも無いので、空文字で素通りさせる。
      var searchText = normText([
        p.title || '',
        p.vendor || '',
        p.product_type || '',
        variant.sku || '',
        (p.tags || []).join(' ').replace(/:/g, ' ')
      ].join(' '));
      var row = {
        searchText: searchText,
        handle: p.handle,
        title: p.title,
        price: variant.price,
        // メーカー希望価格。ここで引き継がないとカードの3段表示から
        // 「メーカー希望価格」の行が落ちる（母集合のJSONには入っている）
        compareAtPrice: p.compareAtPrice,
        // 送料。ここで引き継がないと、母集合のJSONに入っていてもカードに出ない
        // （compareAtPrice と同じ罠）。0 は「送料込」の実データなので落とさない。
        shippingPrice: p.shippingPrice,
        // ブロンズ会員価格（円）。同じ罠。落とすと会員価格だけ率の計算値になる。
        bronzePrice: p.bronzePrice,
        image: img ? (img.src || img) : (p.featured_image || ''),
        // 画像の枚数（No.55）。2枚以上ならカードに矢印を出す。products.json のフォールバックは
        // image_count を持たないが、全画像を返すので images の長さで数えられる
        imageCount: p.image_count != null ? p.image_count : (p.images || []).length,
        vendor: p.vendor,
        published: publishedOf(p),
        v: v
      };
      if (x) row.x = true;
      else axisRows.push(row);
      rows.push(row);
    });

    return { axes: axesFrom(values, holders, axisProducts.length || 1, axisRows), products: rows };
  }

  // 「どの軸を出すか」の規則。商品から作った集計でも、焼き込みの集計でも同じものを通す。
  //   values  … 軸 -> { 値: 1 }（バケット化・単位正規化まで済ませたもの）
  //   holders … 軸 -> その軸を1つ以上持つ商品数
  //   total   … 母集合の件数
  // 分けておかないと焼き込み側で同じ条件をもう一度書くことになり、
  // 片方だけ直したときに「焼き込みだと軸が1本多い」のような食い違いが黙って出る。
  function axesFrom(values, holders, total, rows){
    if (DEF) return axesFromDef(values, holders, total, rows);
    function collectAxes(){
      var out = [];
      Object.keys(values).forEach(function(key){
        var vals = Object.keys(values[key]);
        // 値が1種類では絞り込みにならないので落とす
        if (vals.length < 2) return;
        // その商品群の一部にしか効かない軸は落とす
        if (holders[key] / total < MIN_COVERAGE) return;
        var allNumeric = vals.every(function(x){ return /^\s*\d/.test(x); });
        vals = (NUMERIC.indexOf(key) >= 0 || allNumeric)
          ? vals.sort(function(a, b){ return numericKey(a) - numericKey(b); })
          // **表示名で並べる。** series はタグの値がローマ字のスラッグ（`saamosu-l`）で、
          // 値のまま並べるとローマ字順になり、画面に出るシリーズ名（サーモスL）と
          // 対応しない並びになる。半角英数字が先、そのあと日本語。
          // かなはこの並びで五十音の順になる。
          : vals.sort(function(a, b){
              var x = dispVal(key, a), y = dispVal(key, b);
              var ax = /^[\x20-\x7E]/.test(x) ? 0 : 1;
              var ay = /^[\x20-\x7E]/.test(y) ? 0 : 1;
              return ax - ay || (x < y ? -1 : x > y ? 1 : 0);
            });
        // 「絞り込み値」に並び順が入っている選択肢は、その順で先頭へ。
        // 登録が無い選択肢は上の並び（数値順／文字コード順）のまま後ろに続く。
        // 一部だけ登録した状態でも壊れないので、重要な軸から少しずつ入れられる。
        vals = orderByMeta(key, vals);
        // 値を持たない商品がいるなら「指定なし」を最後に足す。
        // 合掌のように「2台用にしか付かない」軸で、単体カーポートが消えてしまうのを防ぐ。
        if (holders[key] < total) vals = vals.concat([NONE_VALUE]);
        out.push({ key: key, label: AXIS_LABELS[key] || key, values: vals,
                   labels: valueLabels(key, vals, rows || []) });
      });
      return out;
    }
    var built = collectAxes();
    built.sort(function(a, b){
      return orderKey(a) - orderKey(b) || (a.key < b.key ? -1 : a.key > b.key ? 1 : 0);
    });
    if (MAX_AXES) built = built.slice(0, MAX_AXES);
    return built;
  }

  // 定義モードの「どの軸を出すか」。定義の items の順・見出しで、書いた軸を全部出す。
  // カバー率・値2つ以上・白リスト・ページ専用の選択肢・並び順の band・軸数の上限は通さない
  // （値の取り込みで定義外の値はもう捨ててある: build / rowsFromIndex / axesFromDigest）。
  //   list    … 選択肢は定義の values の順（未登録の値は来ない）
  //   numeric … 刻み（canonUnit → bucketsOf）は従来どおり。数値順に並べてから values_order を先に
  //             区分（ranges）を書いた項目は 区分の順 → その他（orderValues は通さない）
  // 値を持たない商品が1件でもいれば「指定なし」を末尾に足す（従来と同じ）。
  function axesFromDef(values, holders, total, rows){
    var out = [];
    DEF_LIB.axisList(DEF).forEach(function(a){
      if (STRUCTURE_AXES.indexOf(a.key) >= 0) return;    // 階層タグは定義に書いても軸にしない
      if (a.key === PRICE_AXIS && !PRICE_BANDS.length) return;   // 価格帯の区切りが無いページは価格を出せない
      var vals = values[a.key] ? Object.keys(values[a.key]) : [];
      var rs = rangesOf(a.key);
      if (rs){
        // 区分を書いた軸: 区分の順（商品の無い区分は出さない）→ その他。unlisted=hide でも「その他」は落とさない
        var got = values[a.key] || {};
        vals = rs.map(function(g){ return g.v; })
          .filter(function(v, i, arr){ return got[v] && arr.indexOf(v) === i; });
        if (got[OTHER_VALUE]) vals.push(OTHER_VALUE);
      } else {
        if (a.show === 'numeric') vals.sort(function(x, y){ return numericKey(x) - numericKey(y); });
        vals = DEF_LIB.orderValues(defItem(a.key), vals);
      }
      if ((holders[a.key] || 0) < total) vals = vals.concat([NONE_VALUE]);
      // 刻みの表記（1600〜1799mm）は numeric だけ。list の表示名は dispVal が定義から引く
      out.push({ key: a.key, label: a.label, values: vals,
                 labels: a.show === 'numeric' ? valueLabels(a.key, vals, rows || []) : {} });
    });
    return out;
  }

  // ---- 絞り込み索引 -------------------------------------------------------
  //
  // **数える係。** 各選択肢の残N件と絞り込み結果は、ここだけで決まる。
  // 母集合の取得やサーバ側の絞り込みは「絵を出す係」に徹し、数字には関与しない。
  //
  // 分けた理由: 以前は同じ入れ物（data.products）に母集合とサーバ結果を載せ、
  // どちらが入っているかをフラグ5つで場合分けしていた。組み合わせが増えるほど
  // 「正しく数えられない時間帯」の取り繕いが増え、実バグが出続けた。
  // 索引があれば**その時間帯そのものが無くなる**ので、場合分けが要らない。
  //
  // 形は scripts/bake_facet_axes.py の build_index() が作る:
  //   {"v":2,"total":N,"vals":["軸\u001f値",…],"p":["0,5,12",…],
  //    "h":["handle",…],"price":[12500,…]}
  var INDEX_ROWS = null;    // 索引から組んだ商品行（v と price だけ。表示項目は持たない）
  var DISPLAY = {};         // handle -> 表示に使う項目（タイトル・画像・価格など）
  // DISPLAY が全商品ぶん揃ったか。索引は数えられても**絵は出せない**ので、
  // 揃うまではタグ取得を表示データの近道として使い続ける。
  var DISPLAY_FULL = false;

  // 索引を1本読む。**読めなければ何もしない**（従来の経路にそのまま落ちる）。
  function loadIndex(){
    var url = (root.getAttribute('data-sg-index-url') || '').trim();
    if (!url || SOURCE === 'search') return Promise.resolve(null);
    return fetch(url)
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if (!j || !(j.v >= 2) || !j.vals || !j.p) return null;
        return SCOPE_TAG ? scopeIndex(j) : j;
      })
      .catch(function(){ return null; });
  }

  // メーカー指定があるとき、索引をそのタグを持つ行だけにする。
  // 索引はコレクション全体で焼かれているので、絞らないと他メーカーの商品も数えて出す。
  // 残した元の行番号は INDEX_KEEP に覚え、商品名の索引（同じ添字）も同じ行に揃える。
  // ⚠️ **タグが値の辞書に無ければ絞れない。** そのときは索引を使わず（null）、
  // ストア側で絞った sgdata の経路に落とす。全体のまま数えるよりは遅い方がまし。
  var INDEX_KEEP = null;      // 絞った索引の行 -> 元の索引の行
  var INDEX_KEEP_FROM = 0;    // 絞る前の行数（商品名の索引と行数を突き合わせる）
  function scopeIndex(ix){
    var cut = SCOPE_TAG.indexOf(':');
    if (cut < 0) return null;
    var want = (SCOPE_TAG.slice(0, cut).trim() + VALUE_SEP + SCOPE_TAG.slice(cut + 1).trim()).toLowerCase();
    var id = -1;
    for (var i = 0; i < ix.vals.length; i++){
      if (String(ix.vals[i]).toLowerCase() === want) { id = String(i); break; }
    }
    if (id === -1) return null;
    var keep = [];
    for (var n = 0; n < ix.p.length; n++){
      if (ix.p[n] && ix.p[n].split(',').indexOf(id) >= 0) keep.push(n);
    }
    if (!keep.length) return null;
    var back = {};
    keep.forEach(function(n, k){ back[n] = k; });
    var out = {};
    for (var key in ix) out[key] = ix[key];
    out.p = keep.map(function(n){ return ix.p[n]; });
    if (ix.h) out.h = keep.map(function(n){ return ix.h[n]; });
    if (ix.price) out.price = keep.map(function(n){ return ix.price[n]; });
    if (ix.x) out.x = ix.x.filter(function(n){ return n in back; }).map(function(n){ return back[n]; });
    out.total = keep.length;
    INDEX_KEEP = keep;
    INDEX_KEEP_FROM = ix.p.length;
    return out;
  }

  // 商品名の索引を1本読む（1回だけ）。読めなければ null を返し、TEXT_FAILED を立てる。
  // 形は配列そのもの、または `{"t":[…]}`。どちらも索引（facet-index）の行と同じ添字。
  // 焼く側（Python）の正規化と食い違っても取りこぼさないよう、ここで normText を
  // 通し直す（同じ規則なので何度通しても同じ文字列になる）。
  function loadTextIndex(){
    if (TEXT_LOAD) return TEXT_LOAD;
    var url = (root.getAttribute('data-sg-text-url') || '').trim();
    if (!url || SOURCE === 'search') { TEXT_FAILED = true; TEXT_LOAD = Promise.resolve(null); return TEXT_LOAD; }
    TEXT_LOAD = fetch(url)
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var t = Array.isArray(j) ? j : (j && Array.isArray(j.t) ? j.t : null);
        if (!t || !t.length) return null;
        return t.map(function(s){ return normText(s); });
      })
      .catch(function(){ return null; })
      .then(function(rows){
        TEXT_ROWS = rows;
        if (!rows) TEXT_FAILED = true;
        return rows;
      });
    return TEXT_LOAD;
  }

  // 商品名の索引を INDEX_ROWS の各行へ `_ntext` として貼る。
  // 貼れたら true。絞り込みの索引がまだ無ければ false（useIndex() が後で呼ぶ）。
  // ⚠️ **行数が索引と合わなければ使わない。** 焼いた時期がずれていると添字がずれ、
  // 別の商品の名前で当たる。黙って食い違うより、従来経路で遅い方がまし。
  function attachTextIndex(){
    if (TEXT_READY) return true;
    if (!TEXT_ROWS || !INDEX_ROWS) return false;
    // 索引をメーカー指定で絞ったときは、商品名の索引も同じ行だけにする（scopeIndex）。
    // 絞る前の行数と合わなければ揃えずに下の不一致に落とす
    if (INDEX_KEEP && TEXT_ROWS.length === INDEX_KEEP_FROM){
      var allText = TEXT_ROWS;
      TEXT_ROWS = INDEX_KEEP.map(function(n){ return allText[n]; });
    }
    if (TEXT_ROWS.length !== INDEX_ROWS.length){
      TEXT_ROWS = null;
      TEXT_FAILED = true;
      resultsWrap.setAttribute('data-sg-text', 'mismatch');
      if (TEXT_Q) ensureDisplayPool();
      return false;
    }
    // 小さいコレクション（build() の searchText）と同じく、タグ「軸:値」でも当てる。
    // 商品名の索引にタグを焼くと LIXIL で 8MB → 25MB になるので、絞り込みの索引が
    // すでに持っている値（帯にまとめる前の生値）をここで足す。
    var tagText = (INDEX_VALS_RAW || []).map(function(entry){
      return normText(entry.split(VALUE_SEP).join(' '));
    });
    for (var i = 0; i < INDEX_ROWS.length; i++){
      var row = INDEX_ROWS[i], extra = '';
      if (row._p){
        var ids = row._p.split(',');
        for (var j = 0; j < ids.length; j++){
          var t = tagText[+ids[j]];
          if (t) extra += ' ' + t;
        }
      }
      row._ntext = TEXT_ROWS[i] + extra;
    }
    TEXT_READY = true;
    resultsWrap.setAttribute('data-sg-text', 'index');
    invalidate();
    return true;
  }

  // 商品名の索引が使えるようになった後の描き直し。件数はこの時点で確定する。
  // カードの絵は数えるのと別で、足りなければ従来どおり母集合から補う
  // （索引は表示項目を持たない。立ち上げ後の裏取得と同じ POOL_CHASE を共有する）。
  function afterTextIndex(){
    if (!TEXT_Q || !data) return;
    render();
    updateTextSearchStatus();
    if (!displayCoversShown()) ensureDisplayPool();
  }

  // 索引から商品行を組む。build() と同じ規則（バケット化・単位の正規化）を通す。
  function rowsFromIndex(ix){
    // 刻みは値の集合だけで決まる。索引の値辞書をそのまま渡せる
    var raw = {};
    ix.vals.forEach(function(entry){
      var i = entry.indexOf(VALUE_SEP);
      if (i < 0) return;
      collectRawValue(raw, entry.slice(0, i), entry.slice(i + 1));
    });
    pitchFromRaw(raw);

    // 値辞書を「軸 -> バケット化後の値の配列」に展開しておく（1回だけ）
    var expanded = ix.vals.map(function(entry){
      var i = entry.indexOf(VALUE_SEP);
      if (i < 0) return null;
      var key = entry.slice(0, i), val = entry.slice(i + 1);
      if (EXCLUDED.indexOf(key) >= 0 || STRUCTURE_AXES.indexOf(key) >= 0) return null;
      var cv = canonUnit(key, val);
      if (DEF && !defKeeps(key, cv)) return null;    // 定義モード: 定義外の key・list の未登録値は捨てる（単位を寄せた値で）
      var vs = bucketsOf(key, cv), fv = fineOf(key, cv);
      return { k: key, vs: fv ? vs.concat([fv]) : vs };   // 実寸も持たせる（build() と同じ）
    });

    // 除外タグ付きの行番号（索引の `x`）。行は残して x: true を立てる（build() と同じ）。
    // 除外が無いコレクションの索引は `x` を持たない
    var xs = {};
    (ix.x || []).forEach(function(i){ xs[i] = 1; });

    var out = [];
    for (var n = 0; n < ix.p.length; n++){
      var v = {};
      var parts = ix.p[n] ? ix.p[n].split(',') : [];
      for (var j = 0; j < parts.length; j++){
        var e = expanded[+parts[j]];
        if (!e) continue;
        var list = v[e.k] || (v[e.k] = []);
        for (var b = 0; b < e.vs.length; b++){
          if (list.indexOf(e.vs[b]) < 0) list.push(e.vs[b]);
        }
      }
      var yen = (ix.price && ix.price[n]) || 0;
      // 価格帯を疑似タグとして持たせる（build() と同じ）
      if (PRICE_BANDS.length && yen > 0 && defKeepsPrice(yen)){
        var lo = 0, hi = null;
        for (var pb = 0; pb < PRICE_BANDS.length; pb++){
          if (yen < PRICE_BANDS[pb]) { hi = PRICE_BANDS[pb]; break; }
          lo = PRICE_BANDS[pb];
        }
        v[PRICE_AXIS] = [hi === null ? (lo + '-') : (lo + '-' + (hi - 1))];
      }
      // ⚠️ **索引はタイトルもタグも持たないので searchText は空のまま。** 商品名検索は
      // 商品名の索引が貼る `_ntext`（attachTextIndex）で当たる。それが無いときだけ
      // dsp() が差し替える DISPLAY 側（build() が normText で作った行）で当たる。
      // ここに生の文字列を入れると、正規化済みの TEXT_Q と食い違って取りこぼす。
      var row = { handle: ix.h ? ix.h[n] : '', price: yen ? String(yen) : '',
                  searchText: '', v: v, _p: ix.p[n] || '' };
      if (xs[n]) row.x = true;
      out.push(row);
    }
    // 商品名検索でタグも当てるために、帯にまとめる前の値辞書を残す（attachTextIndex）
    INDEX_VALS_RAW = ix.vals;
    return out;
  }

  // 索引経路で表示データが届いたときの描き直し。
  //
  // ⚠️ **商品名検索中は軸の生き死にが DISPLAY に依存する。** 索引はタイトルを持たない
  // ので、DISPLAY が空の時点で数えると全軸が「母数0」で落ち、activeAxes() が
  // 0軸を返す。索引経路は renderResults() しか呼ばないため、そのサイドバーが
  // **絞り込み0件のまま固まる**（`?filter.q=` で開いたページで実測: 選択肢0件。
  // ライブは43件）。表示データが届いたら軸から組み直す。
  //
  // 検索していないときは軸は索引だけで決まるので、グリッドと件数だけ描き直す。
  // render() は `shown` を 0 に戻すので、「さらに表示」で伸ばした表示が縮む。
  function repaintIndex(){
    if (TEXT_Q) render(); else renderResults();
  }

  // 表示に使う項目を覚える。**数字には関与しない。**
  function rememberDisplay(products){
    var added = 0;
    (products || []).forEach(function(p){
      if (!p || !p.handle) return;
      if (!DISPLAY[p.handle]) added++;
      DISPLAY[p.handle] = p;
    });
    // ⚠️ **増えたらキャッシュを捨てる。** filtered() は CACHE_GEN 世代で持ち回るので、
    // 捨てないと商品名検索中の集合が打鍵時点で凍り、DISPLAY が後から届いても反映されない。
    // さらに DISPLAY_FULL が真になった瞬間に countsAreSettled() が真になるため、
    // **古い部分集合の件数と「さらに表示（残りN件）」が確定値として出る**。
    if (added) invalidate();
  }

  // 焼き込みを読む。無ければ null（従来どおり母集合から組む）。
  // 焼き込みの値キーの区切り。scripts/bake_facet_axes.py の VALUE_SEP と必ず同じ文字にする。
  var VALUE_SEP = '\u001f';

  function readDigest(){
    // ⚠️ **セクションIDで引く。** 焼き込みの <script> は root（#SelectionGuide-…）の
    // 中ではなく外に出ているので、`root.parentNode.querySelector` では見つからない。
    // 実測: これで readDigest() が常に null を返し、焼き込みが一度も使われないまま
    // 「軸が出ている」ので気づけなかった（検証も母集合同士を比べて合格していた）。
    // document 全体を舐めると同じセクションが2つ載ったときに先頭を掴むので、ID で引く。
    // メーカー指定があるときは使わない（コレクション全体の件数。Liquid 側も出していない）
    if (SCOPE_TAG) return null;
    var el = document.getElementById('SGBaked-' + sectionId);
    if (!el) return null;
    try {
      var j = JSON.parse(el.textContent);
      // v1 は生値ごとに数えていてバケット軸を二重計上する。古い焼き込みが
      // 残っていても読まない（嘘の件数を出すくらいなら従来どおり母集合を待つ）。
      if (!j || !(j.v >= 2) || !j.axes || !(j.total > 0)) return null;
      return j;
    } catch (e) { return null; }
  }

  // 焼き込みの集計から軸と件数を作る。規則は build() と同じ関数（axesFrom）を通す。
  //
  // 焼き込みは**生値のまま**入っている。バケット化（`W:785` -> `600-799`）・
  // 単位の正規化・価格帯まとめは、ここで build() と同じ関数を通してやる。
  // 焼き込み側でやると二重実装になり、片方だけ直したときに黙って食い違う。
  //
  // 件数の足し合わせについて: 1商品が同じ軸に生値を2つ持ち、その2つが同じバケットへ
  // 落ちると二重に数えてしまう。本番実測（sash-window 20,463商品）では、
  // バケット化する軸（W/H）に複数値を持つ商品は**0件**で、複数値があるのは
  // series/ガラス仕様などバケット化しない軸だけだった。バケット化しない軸は
  // 生値がそのまま選択肢なので、足し合わせても二重にならない。
  function axesFromDigest(dg){
    if (DEF) dg = defDigest(dg);
    autoBucketWidthsFromDigest(dg);
    var values = {}, holders = {}, counts = {}, total = dg.total;
    Object.keys(dg.axes).forEach(function(key){
      if (EXCLUDED.indexOf(key) >= 0 || STRUCTURE_AXES.indexOf(key) >= 0) return;
      var ent = dg.axes[key], vmap = ent.v || {};
      holders[key] = ent.h || 0;
      values[key] = {}; counts[key] = {};
      Object.keys(vmap).forEach(function(combo){
        var n = vmap[combo];
        // キーは「1商品がその軸に持つ値の組」。組ごとにバケットの和集合を作り、
        // **バケットごとに1回だけ**足す。生値ごとに足すと、同じバケットへ落ちる
        // 値を2つ持つ商品を二重に数える（実測 bath: 間口(cm) が 33 → 35 になった）。
        var seen = {};
        combo.split(VALUE_SEP).forEach(function(raw){
          bucketsOf(key, canonUnit(key, raw)).forEach(function(b){ seen[b] = 1; });
        });
        Object.keys(seen).forEach(function(b){
          values[key][b] = 1;
          counts[key][b] = (counts[key][b] || 0) + n;
        });
      });
      if (holders[key] < total) counts[key][NONE_VALUE] = total - holders[key];
    });
    // 価格帯。焼き込みは生の価格しか持たない（帯の刻みはセクション設定なので）。
    if (PRICE_BANDS.length && dg.price && dg.price.v && (!DEF || defItem(PRICE_AXIS))){
      values[PRICE_AXIS] = {}; counts[PRICE_AXIS] = {};
      holders[PRICE_AXIS] = dg.price.h || 0;
      Object.keys(dg.price.v).forEach(function(raw){
        var yen = parseFloat(raw);
        if (!(yen > 0)) return;
        // 定義モードで登録の無い価格帯は「指定なし」へ回す（値を持つ商品数から引く）
        if (!defKeepsPrice(yen)) { holders[PRICE_AXIS] -= dg.price.v[raw]; return; }
        var lo = 0, hi = null;
        for (var i = 0; i < PRICE_BANDS.length; i++){
          if (yen < PRICE_BANDS[i]) { hi = PRICE_BANDS[i]; break; }
          lo = PRICE_BANDS[i];
        }
        var band = hi === null ? (lo + '-') : (lo + '-' + (hi - 1));
        values[PRICE_AXIS][band] = 1;
        counts[PRICE_AXIS][band] = (counts[PRICE_AXIS][band] || 0) + dg.price.v[raw];
      });
      if (holders[PRICE_AXIS] < total) counts[PRICE_AXIS][NONE_VALUE] = total - holders[PRICE_AXIS];
    }
    return { axes: axesFrom(values, holders, total, []), counts: counts };
  }
  // 定義モードの焼き込み。軸の組から定義外の key・list の未登録値を除いた写しを返す
  // （全部消えた組の件数は値を持つ商品数 h から引かれ、「指定なし」へ回る）。元の焼き込みは書き換えない。
  // list の軸は、組の生値を build() と同じく canonUnit で寄せてから定義と突き合わせる
  // （`405mm` と `405` は同じ値。寄せた結果が同じになる組は件数を合わせる）
  function defDigest(dg){
    var own = Object.prototype.hasOwnProperty, out = {}, axes = {};
    for (var k in dg) if (own.call(dg, k)) out[k] = dg[k];
    Object.keys(dg.axes || {}).forEach(function(key){
      var ent = dg.axes[key];
      if (!defIsList(key) || !ent || !ent.v) { axes[key] = ent; return; }
      var nv = {};
      Object.keys(ent.v).forEach(function(combo){
        var parts = [];
        combo.split(VALUE_SEP).forEach(function(raw){
          var cv = canonUnit(key, raw);
          if (parts.indexOf(cv) < 0) parts.push(cv);
        });
        var c2 = parts.join(VALUE_SEP);
        nv[c2] = (nv[c2] || 0) + ent.v[combo];
      });
      var copy = {};
      for (var f in ent) if (own.call(ent, f)) copy[f] = ent[f];
      copy.v = nv;
      axes[key] = copy;
    });
    out.axes = DEF_LIB.filterDigestAxes(DEF, axes);
    return out;
  }
  // 定義の軸のうち、焼き込みに無いものがあるか。あれば焼き込みは使わない（母集合で描く）。
  // 焼き込みに無い軸は件数を作れず、定義どおりの画面にならない（夜間の焼き込みより後に定義を足した等）。
  // 軸にしないもの（階層タグ・価格帯の区切りが無いページの price）は見ない
  function defMissingInDigest(dg){
    var list = DEF_LIB.axisList(DEF);
    for (var i = 0; i < list.length; i++){
      var key = list[i].key;
      if (STRUCTURE_AXES.indexOf(key) >= 0) continue;
      if (key === PRICE_AXIS){
        if (!PRICE_BANDS.length) continue;
        if (!dg.price || !dg.price.v) return true;
        continue;
      }
      if (!dg.axes || !Object.prototype.hasOwnProperty.call(dg.axes, key)) return true;
    }
    return false;
  }

  // 焼き込みの件数をそのまま使ってよいか。
  //
  // 各選択肢の残N件は「その軸を除いた選択に合う商品」を母数に数える。
  // **その軸以外に選択が無く、商品名検索もしていない**なら母数は母集合そのもので、
  // 焼き込みの集計と一致する。そこだけが安全に使える範囲。
  // 母集合を持っているなら、当然そちらが正しいので使わない。
  function digestUsable(axKey){
    if (!DIGEST_COUNTS || POOL_FULL || TEXT_Q) return false;
    var list = selList();
    for (var i = 0; i < list.length; i++){ if (list[i].k !== axKey) return false; }
    return true;
  }
  // 未選択時の件数表示に使う全件数。`total` は軸の母数（絞り込み対象外を除く）なので、
  // 一覧に出る件数は `total_all`（除外付きも含む）を優先する。旧い焼き込みには無いので `total` へ戻す
  function digestShownTotal(){
    return DIGEST.total_all > 0 ? DIGEST.total_all : DIGEST.total;
  }
  // その軸を除いた母集合の**件数**。母集合が無くても焼き込みなら分かる。
  // 絞り込み対象外（x）の行は countsFor() と同じく数えない。母数だけに入れると
  // 全選択肢が母数を下回り、activeAxes() の discriminates とカバー率がずれる。
  function baseSize(axKey){
    if (digestUsable(axKey)) return DIGEST.total;
    var list = baseFor(axKey), n = 0;
    for (var i = 0; i < list.length; i++){ if (!list[i].x) n++; }
    return n;
  }

  // 表示名。絞り込みの実行はタグの生値で行い、見せ方だけ差し替える。
  //   maker  : タグ値はローマ字（lixil）。メーカー名のマップで引く。
  //            vendor は使えない。軸に並べる選択肢の一覧が必要で、vendor は
  //            商品1件ぶんのメーカー名しか持たないため。
  //   series : タグ値はスラッグ（saamosu-l）。子コレクションのタイトルが正しい表示名
  //   数値軸 : 1600-1799 -> 1600〜1799mm
  function valueLabels(key, vals, rows){
    var map = {};
    var unit = UNITS[key] || '';
    vals.forEach(function(v){
      if (v === NONE_VALUE) {
        map[v] = NONE_LABEL;
      } else if (v === OTHER_VALUE) {
        map[v] = OTHER_LABEL;
      } else if (key === 'maker') {
        if (MAKER_LABELS[v]) map[v] = MAKER_LABELS[v];
      } else if (key === 'series') {
        if (SERIES_LABELS[v]) map[v] = SERIES_LABELS[v];
      } else if (unit) {
        var base = /-/.test(v) ? v.replace('-', '〜') : v;
        // `180(2口コンロ)` のように括弧書きが付く値は、単位を括弧の前に入れる。
        // 後ろに付けると `180(2口コンロ)cm` になって読めない。
        var paren = base.match(/^([^(（]+)([(（].*)$/);
        map[v] = paren ? paren[1] + unit + paren[2] : base + unit;
      }
    });
    return map;
  }

  // ---- 立ち上げ -----------------------------------------------------------
  // 2段構えにする。
  //   1段目: 1ページ目が着いた時点で商品カードだけ描く（軸はスケルトンのまま）
  //   2段目: 全ページ揃ったら軸と件数を確定させる
  // 以前は全ページを `Promise.all` で待ってから初めて何かを描いていたので、
  // 商品数に比例して何も出ない時間があった（2,000件級で数リクエストぶん）。
  //
  // **軸を1ページ目で描かない**のは意図。軸ごとの残N件は母集合が全部揃わないと
  // 正しくないので、途中の数字を見せてから書き換えると数が踊る。
  // 商品カードはコレクションの並び順の先頭から来るので、途中でも正しい。
  function paintProducts(products){
    learnLiveOrder(products);    // 1ページ目＝いまの並びの先頭
    var built = build(products);
    if (!built.products.length) return;
    // 表示に使う項目を覚える。**索引が数える係を持っていれば母集合は触らない。**
    rememberDisplay(built.products);
    if (INDEX_ROWS){ repaintIndex(); return; }
    // 焼き込みで軸が既に立っているなら、軸は残して商品だけ入れる。
    // 1ページ目だけから組んだ軸は母集合の一部から作った偏ったものなので使わない。
    if (DIGEST_COUNTS){
      // ⚠️ サーバ経由で据えた上位集合を、母集合の1ページ目（**絞り込み前の
      // 先頭250件**）で潰さない。潰すと SERVER_DONE が true のまま
      // 「先頭250件を絞った数」を確定値として出し、件数が 16 → 3 → 16 と踊る。
      // 軸は0.25秒で出るのに1ページ目はそれより遅く着くので、この PR が最適化した
      // 「軸が出た直後に押す」操作で必ず踏む。
      POOL_ROWS = built.products;
      if (SERVER_ROWS && !POOL_FULL) { renderResults(); return; }
      data.products = built.products;
    } else {
      data = { title: document.title, mode: 'flat', axes: [], products: built.products };
      axes = [];
    }
    invalidate();                // 母集合が入れ替わったので件数キャッシュを捨てる
    PARTIAL = true;
    renderResults();
  }

  // ---- 母集合を待たずに絞り込む -------------------------------------------
  //
  // 軸は焼き込みで約0.25秒で出るのに、**押しても効くまで8〜18.6秒**かかっていた。
  // 母集合（全ページ）が揃うのを待っていたため。実測（本番 2026-09-06）:
  //   exterior 11.8秒 / sash-window 18.6秒 / kitchen 8.4秒 / entrance-door 8.3秒
  // 内訳は取得の往復だけで、**取得後のJSは72ms**。帯域も問題ない。
  //
  // 旧タグURL `/collections/{handle}/{軸:値}` は Liquid の collection.products を
  // そのタグで絞ってくれる（実測 0.23秒 / 54件 / 1ページ）。
  // **軸間はANDなので、選ばれたどれか1つのタグで引いた集合は最終結果の上位集合**になる。
  // あとはいつも通りクライアント側で絞れば結果はぴったり合う。
  //
  // ⚠️ 使えない場合がある。バケット化した軸の値（`W:600-799`）は**実在するタグではない**
  // （生タグは `W:785` のような実寸で、バケットは実行時に JS が作っている）。
  // 実タグの軸が1つも選ばれていないときは、従来どおり母集合を待つ。
  var TAG_POOL = {};        // タグ -> Promise（同じタグは一度しか取らない）
  var SERVER_ROWS = null;   // サーバから引いた上位集合（build 済み）
  var POOL_ROWS = null;     // 母集合の経路で入った商品（サーバ経由から戻すときの差し戻し先）
  var serverGen = 0;        // 取得の世代。進めると飛んでいる取得の結果を捨てる
  // この画面で自分が選んだか。**URL から復元したのか、自分で押したのかを区別する。**
  var USER_PICKED = false;
  // サーバから**全ページ**引き終えたか。上位集合を絞った結果は最終結果そのものなので、
  // ここが true なら母集合が無くても**件数は正確**。
  var SERVER_DONE = false;

  // その軸の値が実在するタグか。バケット化していない軸なら生値がそのままタグ。
  function isRealTag(axKey, val){
    if (val === NONE_VALUE) return false;
    if (axKey === PRICE_AXIS) return false;      // 価格帯は疑似タグ
    return !isBucketed(axKey);                   // 刻み・区分を持つ軸はバケット値なので実タグでない
  }

  // いまの選択のうち、サーバで引ける値を1つ選ぶ。**一番絞れそうなものを選ぶ**
  // （焼き込みが件数を持っているので、件数の小さいものを取る）。
  function anchorTag(){
    var best = null;
    selList().forEach(function(sel_){
      // ⚠️ **軸内は OR。** その軸で2つ以上選ばれていると、1つのタグで引いた集合は
      // 最終結果の**部分集合**になり、上位集合にならない。
      // 例: maker で lixil と ykkap の両方を選ぶと、ykkap だけで引いた集合には
      // LIXIL の商品が入っておらず、絞り込み結果から黙って消える。
      // 「軸間はANDだから上位集合」が成り立つのは、その軸の選択値が1つのときだけ。
      if (sel_.vals.length !== 1) return;
      var v = sel_.vals[0];
      if (!isRealTag(sel_.k, v)) return;
      var n = (DIGEST_COUNTS && DIGEST_COUNTS[sel_.k] && DIGEST_COUNTS[sel_.k][v]) || Infinity;
      if (!best || n < best.n) best = { key: sel_.k, val: v, n: n };
    });
    return best;
  }

  // 旧タグURLで引く。**1ページ目が来た時点でいったん返す。**
  //
  // 画面に出るのは先頭48件だけなので、全ページ揃うのを待つ必要がない。
  // 実測: 広いタグ（`maker:lixil` は exterior で5,734件）だと全ページ取得は
  // 母集合と同じ規模になり6〜7.6秒かかった。1ページ目なら約0.3秒。
  //
  // 残りは裏で追い、揃ったら `onDone` で呼び直す（そこで各選択肢の残N件が確定する）。
  //
  // `onChunk(追加ぶん)` を渡すと、**それが true を返した時点で追うのをやめる**。
  // 止めた続きは entry.more に残るので、同じタグでもう一度呼べば再開する。
  function fetchByTag(key, val, onFirst, onDone, onChunk){
    var tag = key + ':' + val;
    if (TAG_POOL[tag]) {                       // 取得済み or 取得中
      var hit = TAG_POOL[tag];
      hit.first.then(onFirst);
      hit.all.then(onDone);
      // 表示に足りて止めていたぶんは、ここから続きを追う（「さらに表示」など）。
      // ⚠️ **取り出してから消す。** 消さないと、同時に呼ばれたぶんだけ chase が重なる。
      if (hit.more){ var go = hit.more; hit.more = null; go(onChunk, onDone); }
      return;
    }
    // メーカー指定があれば、そのタグと AND で引く（他メーカーを混ぜない）
    var base = '/collections/' + handle + scopePath(tag) + '?view=sgdata&page=';
    var firstResolve, allResolve;
    var entry = {
      first: new Promise(function(r){ firstResolve = r; }),
      all: new Promise(function(r){ allResolve = r; }),
      more: null            // 表示に足りて止めたときの「続き」
    };
    TAG_POOL[tag] = entry;

    // ⚠️ **失敗を黙って捨てない。** 捨てて「確定」にすると、429 で欠けたぶんだけ
    // 少ない件数を正しい数として出す。母集合の経路は同じ事故（面格子 3,501件が
    // 1,000件で止まった / Refs #547）のあとにリトライと不完全フラグを持っている。
    // 新しい経路にも同じものを入れる。本番は Cloudflare で 429 が出る環境。
    var tagIncomplete = false;
    function get(n, tries){
      tries = tries || 0;
      return fetch(base + n)
        .then(function(r){
          if (r.ok) return r.text();
          // 429 / 5xx は少し待って数回だけやり直す
          if ((r.status === 429 || r.status >= 500) && tries < 3){
            return new Promise(function(res){ setTimeout(res, 400 * (tries + 1)); })
              .then(function(){ return get(n, tries + 1); })
              .then(function(j){ return j ? JSON.stringify(j) : ''; });
          }
          tagIncomplete = true;
          return '';
        })
        .then(function(t){
          if (!t) return null;
          try { return JSON.parse(t); } catch (e) { tagIncomplete = true; return null; }
        })
        .catch(function(){ tagIncomplete = true; return null; });
    }
    get(1).then(function(j){
      var acc = (j && j.products) || [];
      // 1件も取れなかった＝この道は使えない。null で呼び側に判断させる
      // ⚠️ 失敗を永久にキャッシュしない。押し直しても同じ壊れ方を繰り返す。
      if (!acc.length) delete TAG_POOL[tag];
      firstResolve(acc.length ? acc : null);
      var pages = (j && j.pages) || 1;
      if (!acc.length || pages <= 1) {
        allResolve(!acc.length ? null
                   : (tagIncomplete ? { list: acc, incomplete: true } : acc));
        return;
      }
      // 残りを CHASE 単位で追う。上限は母集合と同じ考え方で 40 ページ
      var next = 2, limit = Math.min(pages, MAX_PAGES);
      // いま持っているぶんを呼び側へ返す形。
      // 上限で打ち切った＝まだ続きがある。確定させない。
      // ⚠️ **表示が足りて止めただけのときは incomplete にしない。** そこで止めたのは
      // 絵の都合で、件数は索引が持っているので欠けていない。
      function result(){
        if (next > limit && limit < pages) tagIncomplete = true;
        return tagIncomplete ? { list: acc, incomplete: true } : acc;
      }
      function chase(want, settle){
        if (next > limit) { entry.more = null; settle(result()); return; }
        var batch = [];
        for (var k = 0; k < CHASE && next <= limit; k++) batch.push(get(next++));
        Promise.all(batch).then(function(js){
          var got = [];
          js.forEach(function(x){
            if (x && x.products) { acc = acc.concat(x.products); got = got.concat(x.products); }
            else tagIncomplete = true;      // 欠けたことを覚えておく
          });
          // 表示に必要なぶんが揃った。残りは要求されたときだけ追う
          if (want && want(got)) {
            entry.more = function(want2, settle2){ chase(want2, settle2); };
            settle(result());
            return;
          }
          chase(want, settle);
        });
      }
      chase(onChunk, allResolve);
    });

    entry.first.then(onFirst);
    entry.all.then(onDone);
  }

  // 焼き込みだけで軸と件数を描く。母集合はまだ無い。
  //
  // `sg-loading` は外さない。絞り込みを押した結果を出すには母集合が要るので、
  // 「見えるのに押すと嘘の結果が出る」状態を作らないため。ここでやるのは
  // **スケルトンを本物の軸と残N件に置き換える**ところまで。
  function activateFromDigest(){
    // 焼き込みを使えたかを画面に出す。**あとから区別できないと誤読する。**
    // 軸が出ていても、それが焼き込み由来か母集合由来かは見た目では分からない。
    var mark = function(v){ resultsWrap.setAttribute('data-sg-baked', v); };
    // ⚠️ **最後まで try で包む。** ここは boot の同期部分から呼ばれていて、
    // IIFE の外側に try/catch は無い。`render()` が投げると例外が IIFE を抜け、
    // `fetchPage(1)` も `bail()` も走らない。bail() の中でしか
    // `#SGHideNative-…`（標準グリッドを隠している style）を外さないので、
    // **商品が1件も見えないページになる**。
    // 母集合の経路は `.catch(bail)` に守られていて復帰できるので、
    // 焼き込みだけが安全網の外にあった。
    try {
      // 定義モードで定義の軸が焼き込みに無いときは使わない（母集合の経路へ）
      if (DEF && defMissingInDigest(DIGEST)) { mark('def-missing'); return false; }
      var built = axesFromDigest(DIGEST);
      if (!built.axes.length) { mark('no-axes'); return false; }
      DIGEST_COUNTS = built.counts;
      data = { title: document.title, mode: resolveMode(built.axes.length),
               axes: built.axes, products: [] };
      axes = data.axes;
      flat = data.mode === 'flat';
      PARTIAL = true;                     // 商品はまだ無い
      // **押せる状態にする。** 軸が見えていれば押したくなるので、押せないほうが不自然。
      // 押した結果は applyPick が「サーバ取得 → 母集合 → 待ち」の順で解決する。
      setLocked(false);
      invalidate();
      disclosure.hidden = flat;
      SUPPRESS_QUERY_WRITE = true;
      try { render(); } finally { SUPPRESS_QUERY_WRITE = false; }
      mark('used');
      return true;
    } catch (e) {
      mark('error:' + (e && e.message ? String(e.message).slice(0, 80) : 'unknown'));
      // 途中まで描いた状態が残っていると中途半端に見える。母集合の経路へ戻す。
      DIGEST_COUNTS = null;
      setLocked(false);
      return false;
    }
  }

  // 索引が届いたら、**数える母集合をそれに差し替える**。
  // 以後、残N件も絞り込み結果も全部ここから決まる。取得の途中経過は関与しない。
  function useIndex(ix){
    try {
      var rows = rowsFromIndex(ix);
      if (!rows.length) return false;
      // 軸の材料は絞り込み対象外（x）を除いた行だけ。build() の axisRows と同じ。
      // 一覧と未選択時の件数には x の行も出すので、INDEX_ROWS には全行を残す
      var axisRows = rows.filter(function(r){ return !r.x; });
      var built = axesFrom(collectFromRows(axisRows), holdersFromRows(axisRows),
                           axisRows.length || 1, axisRows);
      if (!built.length) return false;
      // ⚠️ **索引が使えたことが確定してから代入する。** 先に代入すると、軸が0本・例外の
      // ときも INDEX_ROWS が真のまま残り、paintProducts() と activate() の early return が
      // 両方走って data.products が空・POOL_FULL も false のまま
      // 「スケルトンのまま商品0枚」で固まる（従来経路へ落ちられなくなる）。
      INDEX_ROWS = rows;
      // 商品名の索引が先に届いていれば、ここで貼る（render() より前に貼れば件数は最初から確定）
      attachTextIndex();
      data = { title: document.title, mode: resolveMode(built.length),
               axes: built, products: rows };
      axes = data.axes;
      flat = data.mode === 'flat';
      PARTIAL = false;          // 索引は全商品ぶん。件数は常に正確
      POOL_FULL = true;         // 母集合の到着を待つ理由が無い
      setLocked(false);
      invalidate();
      disclosure.hidden = flat;
      resultsWrap.setAttribute('data-sg-source', 'index');
      // 母集合の到着状況は検証で使うので索引経路でも出す（従来は activate だけが立てていた）。
      resultsWrap.setAttribute('data-sg-pool', POOL_FULL ? 'full' : 'partial');
      // 件数が確定した＝「さらに表示」を押してよい。立てないと `.sg-loading` の
      // ルールで押せないままになり、残り件数だけが出て 49 件目以降へ行けない。
      setExact();
      var seeded = restoreFromQuery();
      render();
      if (seeded) scrollToResults();
      return true;
    } catch (e) {
      // ⚠️ 途中まで進んでいても索引は使わない。従来経路へ落ちられるようにする。
      INDEX_ROWS = null;
      TEXT_READY = false;       // 貼った先の行ごと捨てた。商品名検索も従来経路に戻す
      resultsWrap.setAttribute('data-sg-source', 'index-error');
      return false;
    }
  }

  // 索引の行から values / holders を作る（axesFrom に渡すため）
  function collectFromRows(rows){
    var values = {};
    for (var i = 0; i < rows.length; i++){
      var v = rows[i].v;
      for (var k in v){
        var m = values[k] || (values[k] = {});
        // 実寸（`=1694`）は選択肢の一覧に入れない。build() と同じ（axValues が必要なときだけ並べる）
        for (var j = 0; j < v[k].length; j++) if (!isFine(v[k][j])) m[v[k][j]] = 1;
      }
    }
    return values;
  }
  function holdersFromRows(rows){
    var h = {};
    for (var i = 0; i < rows.length; i++){
      for (var k in rows[i].v) h[k] = (h[k] || 0) + 1;
    }
    return h;
  }

  function activate(products){
    var built = build(products);
    rememberDisplay(built.products);
    // 取り逃がしたページが無ければ、表示に使う項目は全商品ぶん揃った
    DISPLAY_FULL = !FETCH_INCOMPLETE;
    // ⚠️ DISPLAY_FULL が変わると countsAreSettled() の答えが変わる。
    // rememberDisplay で1件も増えなかった場合もここで捨てる。
    invalidate();
    // 索引が数える係を持っている。母集合は表示用にだけ使う
    if (INDEX_ROWS){
      // ⚠️ **ここで `sg-loading` を外す。** 外さないと索引経路では
      // 一生外れない（この early return が下の remove まで届かせない）ので、
      // 並び替え [data-sg-sort] が pointer-events: none のまま残る。
      // 商品名検索は #547 で読み込み中も入力できるようにしている。
      //
      // 取り逃がしたページがあっても外す。母集合は40ページ（10,000件）で
      // 打ち止めなので、`FETCH_INCOMPLETE` で塞ぐと sash-window（19,586件）
      // maker-lixil（24,416件）では**恒久的に操作できなくなる**。
      // 数えられない件数は countsAreSettled() が空欄にして守る。
      resultsWrap.classList.remove('sg-loading');
      setLocked(false);
      repaintIndex();
      return true;
    }
    if (!built.axes.length) return false;                    // 軸が立たない
    data = { title: document.title, mode: resolveMode(built.axes.length),
             axes: built.axes, products: built.products };
    axes = data.axes;
    flat = data.mode === 'flat';
    invalidate();                // 1ページ目 -> 全件 で母集合が入れ替わる
    // 母集合を集めきれたときだけ件数を出す。取り逃がしたページがあるまま件数を
    // 確定させると、絞り込み前より少ない数字が出て嘘になる（Refs #547）。
    // コレクション側の TOTAL（all_products_count）は非公開分も数えるぶん実際より
    // 多いことがあるので、件数の一致では判定せず取得の失敗だけを見る。
    // ⚠️ 判定に「手元の件数が TOTAL に届いたか」を使ってはいけない。TOTAL は
    // 検索なら search.results_count（記事・ページも数える）、コレクションなら
    // all_products_count（非公開分も数える）で、どちらも商品の実数より多くなる。
    // 一致を待つと永久に PARTIAL のままで件数が出ない。見るのは取得の成否だけ。
    PARTIAL = FETCH_INCOMPLETE;
    // 母集合が揃った。以降は焼き込みではなく手元の商品から数える
    // （焼き込みは初回描画用のキャッシュであって正典ではない）。
    POOL_FULL = !FETCH_INCOMPLETE;
    // 母集合を集めきれたかを画面に出す。検証で「焼き込みと母集合が一致した」と
    // 言えるのは集めきれたときだけで、集めきれていないと**どちらも焼き込み由来**に
    // なって比較が空振りする（一致したように見えるだけ）。
    resultsWrap.setAttribute('data-sg-pool', POOL_FULL ? 'full' : 'partial');
    setLoadingResults(false);       // 待たせていた結果があれば解除
    // ⚠️ 世代を進めて、飛んでいるタグ取得を無効にする。POOL_FULL が false のまま
    // （429 のリトライ失敗・40ページ上限）だと use() の `if (POOL_FULL) return` にも
    // 掛からず、着弾した結果が母集合を上書きする。
    serverGen++;
    SERVER_ROWS = null;             // 母集合が揃った。上位集合は要らない
    SERVER_DONE = false;
    ANCHOR_AX = null;
    // ⚠️ **差し戻し先も更新する。** ここを忘れると、母集合を集めきれなかったとき
    // （FETCH_INCOMPLETE で POOL_FULL が false のまま）に解除すると
    // data.products が1ページ目250件に落ち、集めた分（最大10,000件）が捨てられる。
    POOL_ROWS = data.products;
    var seeded = restoreFromQuery();
    disclosure.hidden = flat;   // L1/L2(flat)=上部ウィザード無し・サイドのみ / L3/L4(step)=ウィザード＋サイド
    resultsWrap.classList.remove('sg-loading');
    setLocked(false);           // 母集合が入った。ここから押せる
    render();
    if (seeded) scrollToResults();
    return true;
  }

  // 母集合を最後まで読めない大きさの検索結果では、ガイドを出さずに標準UIへ戻す。Refs #547
  //
  // 検索の母集合は1ページ50件で、MAX_PAGES ぶん（10,000件）まで集められる。
  // 一覧に出るのも軸ごとの残N件も手元に集まった母集合から数えるので、そこを超える
  // 検索語（`q=*`・本番 25,001件）で無理にガイドを出すと、絞り込みの軸が母集合の
  // 先頭 10,000件だけから作った偏った集合になる。全体を扱えない以上、標準の絞り込みと
  // ページング（`#ResultsList` と facets ブロック）に任せるのが正しい。
  // 標準側の件数は25,000件を超えると「25,000点超のアイテム」で頭打ちにするので、
  // 数字が踊ることもない（blocks/filters.liquid）。
  //
  // コレクション側は `all_products_count` が非公開分も数える（実際に読める件数より
  // 多く出る）ので、ここでは判定しない。
  if (SOURCE === 'search' && TOTAL > PAGE_SIZE * MAX_PAGES) {
    bail();
    return;
  }

  // 埋め込みがあるページは、その場で軸まで確定させる。取得も待ちも無いので
  // スケルトンは一度も見えない。
  // ここまで来れば母集合の取得に要る設定（PAGE_SIZE / TOTAL）は全部そろっている。
  BOOTED = true;
  var inlineAll = SOURCE === 'search' ? null : inlineProducts();
  if (inlineAll) {
    INLINE_USED = true;
    POOL_FULL = true;
    if (!activate(inlineAll)) bail();
  } else {
    // 埋め込みが無い（251件以上の）ページは、焼き込みがあれば先に軸を描く。
    // 母集合を全ページ取り終わるまでスケルトンだった 15.4秒（本番 sash-window 実測）が
    // ここで消える。取得は今までどおり裏で走り、揃ったら activate() が組み直す。
    // ⚠️ ここは同期。何かが投げると fetchPage(1) も bail() も走らず、
    // 標準グリッドが隠れたままのページが残る。二重に網を張る。
    try {
      DIGEST = SOURCE === 'search' ? null : readDigest();
      if (!DIGEST) resultsWrap.setAttribute('data-sg-baked', 'none');
      if (DIGEST && !activateFromDigest()) DIGEST = null;
    } catch (e) {
      DIGEST = null;
      DIGEST_COUNTS = null;
      try { resultsWrap.setAttribute('data-sg-baked', 'boot-error'); } catch (e2) {}
    }

    // 索引を並行して読む。届いたら**数える母集合をそれに差し替える**。
    // CDN 配信で数十msなので、焼き込みの表示からほぼ間を置かずに
    // 「押せば正しい残N件が出る」状態になる。
    // 読めなければ何もしない＝従来の経路にそのまま落ちる（後退しない）。
    // リロードでブラウザが並び替えを復元していた場合（Firefox）、
    // applySort() は BOOTED がまだ立っておらず取りに行けなかった。ここで拾う。
    if (needsFullDisplay()) ensureDisplayPool();

    // 索引が使えたかを立ち上げ側にも渡す。
    var indexReady = loadIndex().then(function(ix){
      if (ix) { if (!useIndex(ix)) resultsWrap.setAttribute('data-sg-source', 'index-unusable'); }
      else if (!resultsWrap.getAttribute('data-sg-source'))
        resultsWrap.setAttribute('data-sg-source', 'none');
      return !!INDEX_ROWS;
    }).catch(function(){ return false; });

    firstPage().then(function(first){
      if (!first.length) { bail(); return null; }
      paintProducts(first);        // ここで商品が見える（軸はまだスケルトン）
      // ⚠️ **索引の返事を待ってから、残りを追うかどうかを決める。** 待たずに
      // fetchRest() へ入ると、索引が45msで届いても40ページぶん（sash-window で
      // 0.98MB）が走り切る。索引経路で母集合が要るのは商品名順・新着順・商品名検索
      // だけなので、それらが押されたとき ensureDisplayPool() が改めて取りに行く
      // （issue #811）。
      return indexReady.then(function(indexed){
        if (indexed) {
          // ⚠️ **索引で描き終えてから、母集合を裏で温めておく。**
          // 取らないでいると、最初に並び替えや商品名検索を押した人が
          // その場で40ページ分を待つ（価格の安い順で実測21秒・#811）。
          // 初回描画の後に回すので、表示は索引だけで先に出る。
          // 絞り込みを押すたびの取り直し（1回につき40リクエスト・0.98MB）は
          // これとは別で、索引が件数を持っているので今後も飛ばさない。
          var warm = function(){ ensureDisplayPool(); };
          // ⚠️ **1画面目に骨のカードが残っているなら、暇になるのを待たずに今すぐ取る。**
          // 索引の並び（おすすめ順）の先頭は1ページ目に収まるとは限らず、2〜4ページ目の
          // 商品が骨のまま idle（最大3秒）＋全ページ取得のあいだ残っていた。
          if (!displayCoversShown()) warm();
          else if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 3000 });
          else setTimeout(warm, 1500);
          return null;
        }
        // 索引が無い経路は従来どおり全ページ追う。**この1本を POOL_CHASE に
        // 覚えさせる。** 覚えないと、商品名検索に入ったとき ensureDisplayPool() が
        // 同じ40ページをもう一度取りに行く。
        POOL_CHASE = fetchRest(first);
        return POOL_CHASE;
      });
    }).then(function(all){
      if (!all || !all.length) return;
      if (!activate(all)) bail();
    }).catch(function(){ bail(); });
  }
};
